msgid ""
msgstr ""
"POT-Creation-Date: 2024-08-04 21:58+0800\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=UTF-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: pt\n"
"Project-Id-Version: phanpy\n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: 2025-04-21 10:17\n"
"Last-Translator: \n"
"Language-Team: Portuguese\n"
"Plural-Forms: nplurals=2; plural=(n != 1);\n"
"X-Crowdin-Project: phanpy\n"
"X-Crowdin-Project-ID: 703337\n"
"X-Crowdin-Language: pt-PT\n"
"X-Crowdin-File: /main/src/locales/en.po\n"
"X-Crowdin-File-ID: 18\n"

#: src/components/account-block.jsx:136
msgid "Locked"
msgstr "Bloqueado"

#. placeholder {0}: shortenNumber(statusesCount)
#: src/components/account-block.jsx:142
msgid "Posts: {0}"
msgstr "Postagens: {0}"

#. placeholder {0}: niceDateTime(lastStatusAt, { hideTime: true, })
#: src/components/account-block.jsx:147
msgid "Last posted: {0}"
msgstr "Última publicação: {0}"

#: src/components/account-block.jsx:162
#: src/components/account-info.jsx:690
msgid "Automated"
msgstr "Automático"

#: src/components/account-block.jsx:169
#: src/components/account-info.jsx:695
#: src/components/status.jsx:588
msgid "Group"
msgstr "Grupo"

#: src/components/account-block.jsx:179
msgid "Mutual"
msgstr "Mútuo"

#: src/components/account-block.jsx:183
#: src/components/account-info.jsx:1762
msgid "Requested"
msgstr "Pedido"

#: src/components/account-block.jsx:187
#: src/components/account-info.jsx:1753
msgid "Following"
msgstr "A seguir"

#: src/components/account-block.jsx:191
#: src/components/account-info.jsx:1144
msgid "Follows you"
msgstr "Segue tu"

#: src/components/account-block.jsx:199
msgid "{followersCount, plural, one {# follower} other {# followers}}"
msgstr "{followersCount, plural, one {# seguidor} other {# seguidores}}"

#: src/components/account-block.jsx:208
#: src/components/account-info.jsx:738
msgid "Verified"
msgstr "Verificado"

#. placeholder {0}: niceDateTime(createdAt, { hideTime: true, })
#. placeholder {0}: niceDateTime(createdAt, { hideTime: true, })
#: src/components/account-block.jsx:223
#: src/components/account-info.jsx:840
msgid "Joined <0>{0}</0>"
msgstr "Juntou-se em <0>{0}</0>"

#: src/components/account-info.jsx:57
msgid "Forever"
msgstr "Permanente"

#: src/components/account-info.jsx:385
msgid "Unable to load account."
msgstr "Impossível carregar conta."

#: src/components/account-info.jsx:400
msgid "Go to account page"
msgstr "Ir à página da conta"

#: src/components/account-info.jsx:429
#: src/components/account-info.jsx:760
#: src/components/account-info.jsx:790
msgid "Followers"
msgstr "Seguidores"

#. js-lingui-explicit-id
#: src/components/account-info.jsx:433
#: src/components/account-info.jsx:800
#: src/components/account-info.jsx:819
msgid "following.stats"
msgstr "A seguir"

#: src/components/account-info.jsx:436
#: src/components/account-info.jsx:836
#: src/pages/account-statuses.jsx:479
#: src/pages/search.jsx:341
#: src/pages/search.jsx:488
msgid "Posts"
msgstr "Postagens"

#: src/components/account-info.jsx:444
#: src/components/account-info.jsx:1200
#: src/components/compose.jsx:2772
#: src/components/media-alt-modal.jsx:46
#: src/components/media-modal.jsx:358
#: src/components/status.jsx:1826
#: src/components/status.jsx:1843
#: src/components/status.jsx:1968
#: src/components/status.jsx:2588
#: src/components/status.jsx:2591
#: src/pages/account-statuses.jsx:523
#: src/pages/accounts.jsx:110
#: src/pages/hashtag.jsx:200
#: src/pages/list.jsx:158
#: src/pages/public.jsx:115
#: src/pages/scheduled-posts.jsx:87
#: src/pages/status.jsx:1232
#: src/pages/trending.jsx:469
msgid "More"
msgstr "Mais"

#: src/components/account-info.jsx:456
msgid "<0>{displayName}</0> has indicated that their new account is now:"
msgstr "A nova conta de <0>{displayName}</0> é:"

#: src/components/account-info.jsx:601
#: src/components/account-info.jsx:1358
msgid "Handle copied"
msgstr "Identificador copiado"

#: src/components/account-info.jsx:604
#: src/components/account-info.jsx:1361
msgid "Unable to copy handle"
msgstr "Impossível copiar identificador"

#: src/components/account-info.jsx:610
#: src/components/account-info.jsx:1367
msgid "Copy handle"
msgstr "Copiar identificador"

#: src/components/account-info.jsx:616
msgid "Go to original profile page"
msgstr "Ir à página do perfil original"

#: src/components/account-info.jsx:634
msgid "View profile image"
msgstr "Ver foto de perfil"

#: src/components/account-info.jsx:651
msgid "View profile header"
msgstr "Ver banner de perfil"

#: src/components/account-info.jsx:666
#: src/components/account-info.jsx:1668
#: src/components/account-info.jsx:2187
msgid "Edit profile"
msgstr "Editar perfil"

#: src/components/account-info.jsx:685
msgid "In Memoriam"
msgstr "Em memória"

#: src/components/account-info.jsx:767
#: src/components/account-info.jsx:810
msgid "This user has chosen to not make this information available."
msgstr "O utilizador deixou privado esta informação."

#. placeholder {0}: ( postingStats.originals / postingStats.total ).toLocaleString(i18n.locale || undefined, { style: 'percent', })
#. placeholder {1}: ( postingStats.replies / postingStats.total ).toLocaleString(i18n.locale || undefined, { style: 'percent', })
#. placeholder {2}: ( postingStats.boosts / postingStats.total ).toLocaleString(i18n.locale || undefined, { style: 'percent', })
#: src/components/account-info.jsx:865
msgid "{0} original posts, {1} replies, {2} boosts"
msgstr "{0} postagens originais, {1} respostas, {2} impulsos"

#. placeholder {0}: postingStats.total
#. placeholder {1}: postingStats.daysSinceLastPost
#. placeholder {2}: postingStats.daysSinceLastPost
#. placeholder {3}: postingStats.daysSinceLastPost
#. placeholder {4}: postingStats.total
#. placeholder {5}: postingStats.total
#. placeholder {6}: postingStats.daysSinceLastPost
#: src/components/account-info.jsx:881
msgid "{0, plural, one {{1, plural, one {Last 1 post in the past 1 day} other {Last 1 post in the past {2} days}}} other {{3, plural, one {Last {4} posts in the past 1 day} other {Last {5} posts in the past {6} days}}}}"
msgstr "{0, plural, one {{1, plural, one {Última postagem no último dia} other {Última postagem nos últimos {2} dias}}} other {{3, plural, one {Últimas {4} postagens no último dia} other {Últimas {5} postagens nos últimos {6} dias}}}}"

#. placeholder {0}: postingStats.total
#. placeholder {1}: postingStats.total
#: src/components/account-info.jsx:897
msgid "{0, plural, one {Last 1 post in the past year(s)} other {Last {1} posts in the past year(s)}}"
msgstr "{0, plural, one {Última postagem no(s) ano(s) passado(s)} other {Últimas {1} postagens no(s) ano(s) passado(s)}}"

#: src/components/account-info.jsx:922
#: src/pages/catchup.jsx:71
msgid "Original"
msgstr "Original"

#: src/components/account-info.jsx:926
#: src/components/status.jsx:2372
#: src/pages/catchup.jsx:72
#: src/pages/catchup.jsx:1447
#: src/pages/catchup.jsx:2062
#: src/pages/status.jsx:955
#: src/pages/status.jsx:1578
msgid "Replies"
msgstr "Respostas"

#: src/components/account-info.jsx:930
#: src/pages/catchup.jsx:73
#: src/pages/catchup.jsx:1449
#: src/pages/catchup.jsx:2074
#: src/pages/settings.jsx:1159
msgid "Boosts"
msgstr "Impulsos"

#: src/components/account-info.jsx:936
msgid "Post stats unavailable."
msgstr "Estatísticas da publicação indisponíveis."

#: src/components/account-info.jsx:967
msgid "View post stats"
msgstr "Ver estatísticas"

#. placeholder {0}: niceDateTime(lastStatusAt, { hideTime: true, })
#: src/components/account-info.jsx:1148
msgid "Last post: <0>{0}</0>"
msgstr "Última publicação: <0>{0}</0>"

#: src/components/account-info.jsx:1162
msgid "Muted"
msgstr "Silenciado"

#: src/components/account-info.jsx:1167
msgid "Blocked"
msgstr "Bloqueado"

#: src/components/account-info.jsx:1176
msgid "Private note"
msgstr "Nota privada"

#: src/components/account-info.jsx:1233
msgid "Mention <0>@{username}</0>"
msgstr "Mencionar <0>@{username}</0>"

#: src/components/account-info.jsx:1245
msgid "Translate bio"
msgstr "Traduzir biografia"

#: src/components/account-info.jsx:1256
msgid "Edit private note"
msgstr "Editar nota privada"

#: src/components/account-info.jsx:1256
msgid "Add private note"
msgstr "Adicionar nota privada"

#: src/components/account-info.jsx:1276
msgid "Notifications enabled for @{username}'s posts."
msgstr "Habilitado as notificações para postagens de @{username}."

#: src/components/account-info.jsx:1277
msgid " Notifications disabled for @{username}'s posts."
msgstr " Desabilitado as notificações de postagens de @{username}."

#: src/components/account-info.jsx:1289
msgid "Disable notifications"
msgstr "Desativar notificações"

#: src/components/account-info.jsx:1290
msgid "Enable notifications"
msgstr "Ativar notificações"

#: src/components/account-info.jsx:1307
msgid "Boosts from @{username} enabled."
msgstr "Impulsos de @{username} ativados."

#: src/components/account-info.jsx:1308
msgid "Boosts from @{username} disabled."
msgstr "Impulsos de @{username} desativados."

#: src/components/account-info.jsx:1319
msgid "Disable boosts"
msgstr "Desativar impulsos"

#: src/components/account-info.jsx:1319
msgid "Enable boosts"
msgstr "Ativar impulsos"

#: src/components/account-info.jsx:1335
#: src/components/account-info.jsx:1345
#: src/components/account-info.jsx:1933
msgid "Add/Remove from Lists"
msgstr "Adicionar/Remover das listas"

#: src/components/account-info.jsx:1384
#: src/components/status.jsx:1253
msgid "Link copied"
msgstr "Ligação copiada"

#: src/components/account-info.jsx:1387
#: src/components/status.jsx:1256
msgid "Unable to copy link"
msgstr "Impossível copiar ligação"

#: src/components/account-info.jsx:1393
#: src/components/shortcuts-settings.jsx:1059
#: src/components/status.jsx:1262
#: src/components/status.jsx:3359
msgid "Copy"
msgstr "Copiar"

#: src/components/account-info.jsx:1408
#: src/components/shortcuts-settings.jsx:1077
#: src/components/status.jsx:1278
msgid "Sharing doesn't seem to work."
msgstr "Partilhar não parece estar a funcionar."

#: src/components/account-info.jsx:1414
#: src/components/status.jsx:1284
msgid "Share…"
msgstr "Partilhar…"

#: src/components/account-info.jsx:1434
msgid "Unmuted @{username}"
msgstr "Dessilenciou @{username}"

#: src/components/account-info.jsx:1446
msgid "Unmute <0>@{username}</0>"
msgstr "Dessilenciar <0>@{username}</0>"

#: src/components/account-info.jsx:1462
msgid "Mute <0>@{username}</0>…"
msgstr "Silenciar <0>@{username}</0>…"

#. placeholder {0}: typeof MUTE_DURATIONS_LABELS[duration] === 'function' ? MUTE_DURATIONS_LABELS[duration]() : _(MUTE_DURATIONS_LABELS[duration])
#: src/components/account-info.jsx:1494
msgid "Muted @{username} for {0}"
msgstr "Silenciou @{username} por {0}"

#: src/components/account-info.jsx:1506
msgid "Unable to mute @{username}"
msgstr "Impossível silenciar @{username}"

#: src/components/account-info.jsx:1527
msgid "Remove <0>@{username}</0> from followers?"
msgstr "Eliminar <0>@{username}</0> dos seguidores?"

#: src/components/account-info.jsx:1547
msgid "@{username} removed from followers"
msgstr "@{username} eliminado dos seguidores"

#: src/components/account-info.jsx:1559
msgid "Remove follower…"
msgstr "Eliminar seguidor…"

#: src/components/account-info.jsx:1570
msgid "Block <0>@{username}</0>?"
msgstr "Bloquear <0>@{username}</0>?"

#: src/components/account-info.jsx:1594
msgid "Unblocked @{username}"
msgstr "Desbloqueou @{username}"

#: src/components/account-info.jsx:1602
msgid "Blocked @{username}"
msgstr "Bloqueou @{username}"

#: src/components/account-info.jsx:1610
msgid "Unable to unblock @{username}"
msgstr "Impossível desbloquear @{username}"

#: src/components/account-info.jsx:1612
msgid "Unable to block @{username}"
msgstr "Impossível bloquear @{username}"

#: src/components/account-info.jsx:1622
msgid "Unblock <0>@{username}</0>"
msgstr "Desbloquear <0>@{username}</0>"

#: src/components/account-info.jsx:1631
msgid "Block <0>@{username}</0>…"
msgstr "Bloquear <0>@{username}</0>…"

#: src/components/account-info.jsx:1648
msgid "Report <0>@{username}</0>…"
msgstr "Reportar <0>@{username}</0>…"

#: src/components/account-info.jsx:1704
msgid "Withdraw follow request?"
msgstr "Eliminar pedido de seguir?"

#. placeholder {0}: info.acct || info.username
#: src/components/account-info.jsx:1705
msgid "Unfollow @{0}?"
msgstr "Deixar de seguir @{0}?"

#: src/components/account-info.jsx:1756
msgid "Unfollow…"
msgstr "Deixar de seguir…"

#: src/components/account-info.jsx:1765
msgid "Withdraw…"
msgstr "Eliminar…"

#: src/components/account-info.jsx:1772
#: src/components/account-info.jsx:1776
#: src/pages/hashtag.jsx:262
msgid "Follow"
msgstr "Seguir"

#: src/components/account-info.jsx:1873
#: src/components/account-info.jsx:1928
#: src/components/account-info.jsx:2062
#: src/components/account-info.jsx:2182
#: src/components/account-sheet.jsx:38
#: src/components/compose.jsx:881
#: src/components/compose.jsx:2728
#: src/components/compose.jsx:3202
#: src/components/compose.jsx:3411
#: src/components/compose.jsx:3641
#: src/components/drafts.jsx:59
#: src/components/embed-modal.jsx:13
#: src/components/generic-accounts.jsx:143
#: src/components/keyboard-shortcuts-help.jsx:43
#: src/components/list-add-edit.jsx:36
#: src/components/media-alt-modal.jsx:34
#: src/components/media-modal.jsx:322
#: src/components/notification-service.jsx:157
#: src/components/report-modal.jsx:75
#: src/components/shortcuts-settings.jsx:230
#: src/components/shortcuts-settings.jsx:583
#: src/components/shortcuts-settings.jsx:783
#: src/components/status.jsx:3083
#: src/components/status.jsx:3323
#: src/components/status.jsx:3832
#: src/pages/accounts.jsx:37
#: src/pages/catchup.jsx:1583
#: src/pages/filters.jsx:225
#: src/pages/list.jsx:276
#: src/pages/notifications.jsx:934
#: src/pages/scheduled-posts.jsx:257
#: src/pages/settings.jsx:87
#: src/pages/status.jsx:1319
msgid "Close"
msgstr "Fechar"

#: src/components/account-info.jsx:1878
msgid "Translated Bio"
msgstr "Biografia traduzida"

#: src/components/account-info.jsx:1973
msgid "Unable to remove from list."
msgstr "Impossível remover da lista."

#: src/components/account-info.jsx:1974
msgid "Unable to add to list."
msgstr "Impossível adicionar na lista."

#: src/components/account-info.jsx:1993
#: src/pages/lists.jsx:105
msgid "Unable to load lists."
msgstr "Impossível carregar listas."

#: src/components/account-info.jsx:1997
msgid "No lists."
msgstr "Sem listas."

#: src/components/account-info.jsx:2008
#: src/components/list-add-edit.jsx:40
#: src/pages/lists.jsx:59
msgid "New list"
msgstr "Nova lista"

#. placeholder {0}: account?.username || account?.acct
#: src/components/account-info.jsx:2067
msgid "Private note about <0>@{0}</0>"
msgstr "Nota privada sobre <0>@{0}</0>"

#: src/components/account-info.jsx:2097
msgid "Unable to update private note."
msgstr "Impossível atualizar nota privada."

#: src/components/account-info.jsx:2120
#: src/components/account-info.jsx:2418
msgid "Cancel"
msgstr "Cancelar"

#: src/components/account-info.jsx:2125
msgid "Save & close"
msgstr "Guardar e fechar"

#: src/components/account-info.jsx:2242
msgid "Unable to update profile."
msgstr "Impossível atualizar perfil."

#: src/components/account-info.jsx:2249
msgid "Header picture"
msgstr "Foto de fundo"

#: src/components/account-info.jsx:2301
msgid "Profile picture"
msgstr "Foto de perfil"

#: src/components/account-info.jsx:2353
#: src/components/list-add-edit.jsx:105
msgid "Name"
msgstr "Nome"

#: src/components/account-info.jsx:2366
msgid "Bio"
msgstr "Biografia"

#: src/components/account-info.jsx:2379
msgid "Extra fields"
msgstr "Campos adicionais"

#: src/components/account-info.jsx:2385
msgid "Label"
msgstr "Etiqueta"

#: src/components/account-info.jsx:2388
msgid "Content"
msgstr "Conteúdo"

#: src/components/account-info.jsx:2421
#: src/components/list-add-edit.jsx:150
#: src/components/shortcuts-settings.jsx:715
#: src/pages/filters.jsx:570
#: src/pages/notifications.jsx:1000
msgid "Save"
msgstr "Guardar"

#: src/components/account-info.jsx:2475
msgid "username"
msgstr "nome de utilizador"

#: src/components/account-info.jsx:2479
msgid "server domain name"
msgstr "domínio do servidor"

#: src/components/background-service.jsx:156
msgid "Cloak mode disabled"
msgstr "Modo oculto desativado"

#: src/components/background-service.jsx:156
msgid "Cloak mode enabled"
msgstr "Modo oculto ativado"

#: src/components/columns.jsx:27
#: src/components/nav-menu.jsx:176
#: src/components/shortcuts-settings.jsx:139
#: src/components/timeline.jsx:463
#: src/pages/catchup.jsx:882
#: src/pages/filters.jsx:90
#: src/pages/followed-hashtags.jsx:41
#: src/pages/home.jsx:54
#: src/pages/notifications.jsx:579
#: src/pages/scheduled-posts.jsx:72
msgid "Home"
msgstr "Página inicial"

#: src/components/compose-button.jsx:142
#: src/compose.jsx:38
msgid "Compose"
msgstr "Escrever"

#: src/components/compose-button.jsx:169
#: src/components/nav-menu.jsx:260
#: src/pages/scheduled-posts.jsx:31
#: src/pages/scheduled-posts.jsx:76
msgid "Scheduled Posts"
msgstr "Publicações Programadas"

#: src/components/compose-button.jsx:182
msgid "Add to thread"
msgstr "Adicionar ao tópico"

#: src/components/compose.jsx:211
msgid "Take photo or video"
msgstr "Fazer foto ou vídeo"

#: src/components/compose.jsx:212
msgid "Add media"
msgstr "Adicionar multimédia"

#: src/components/compose.jsx:213
msgid "Add custom emoji"
msgstr "Adicionar emoji personalizado"

#: src/components/compose.jsx:214
msgid "Add GIF"
msgstr "Adicionar GIF"

#: src/components/compose.jsx:215
msgid "Add poll"
msgstr "Adicionar enquete"

#: src/components/compose.jsx:216
msgid "Schedule post"
msgstr "Programar publicação"

#: src/components/compose.jsx:415
msgid "You have unsaved changes. Discard this post?"
msgstr "Tem alterações não guardadas. Desfazer publicação?"

#. placeholder {0}: unsupportedFiles.length
#. placeholder {1}: unsupportedFiles[0].name
#. placeholder {2}: lf.format( unsupportedFiles.map((f) => f.name), )
#: src/components/compose.jsx:644
msgid "{0, plural, one {File {1} is not supported.} other {Files {2} are not supported.}}"
msgstr "{0, plural, one {O ficheiro {1} não é suportado.} other {Os ficheiros {2} não são suportados.}}"

#: src/components/compose.jsx:654
#: src/components/compose.jsx:672
#: src/components/compose.jsx:1777
#: src/components/compose.jsx:1902
msgid "{maxMediaAttachments, plural, one {You can only attach up to 1 file.} other {You can only attach up to # files.}}"
msgstr "{maxMediaAttachments, plural,one {Só pode anexar até 1 ficheiro.} other {Só pode anexar até # ficheiros.}}"

#: src/components/compose.jsx:862
msgid "Pop out"
msgstr "Fechar"

#: src/components/compose.jsx:869
msgid "Minimize"
msgstr "Minimizar"

#: src/components/compose.jsx:905
msgid "Looks like you closed the parent window."
msgstr "Parece que fechaste a janela principal."

#: src/components/compose.jsx:912
msgid "Looks like you already have a compose field open in the parent window and currently publishing. Please wait for it to be done and try again later."
msgstr "Parece que já tem um campo de edição aberto na janela principal e atualmente está a publicar. Espere até que esteja concluído e tenta novamente mais tarde."

#: src/components/compose.jsx:917
msgid "Looks like you already have a compose field open in the parent window. Popping in this window will discard the changes you made in the parent window. Continue?"
msgstr "Parece que já tem um campo de edição aberto na janela principal. Abrindo esta janela irá desfazer as alterações que fizeste na janela principal. Prosseguir?"

#: src/components/compose.jsx:960
msgid "Pop in"
msgstr "Abrir"

#. placeholder {0}: replyToStatus.account.acct || replyToStatus.account.username
#. placeholder {1}: rtf.format(-replyToStatusMonthsAgo, 'month')
#: src/components/compose.jsx:970
msgid "Replying to @{0}’s post (<0>{1}</0>)"
msgstr "A responder à publicação de @{0} (<0>{1}</0>)"

#. placeholder {0}: replyToStatus.account.acct || replyToStatus.account.username
#: src/components/compose.jsx:980
msgid "Replying to @{0}’s post"
msgstr "A responder à publicação de @{0}"

#: src/components/compose.jsx:993
msgid "Editing source post"
msgstr "A editar publicação original"

#: src/components/compose.jsx:1046
msgid "Poll must have at least 2 options"
msgstr "A enquete deve ter no mínimo 2 opções"

#: src/components/compose.jsx:1050
msgid "Some poll choices are empty"
msgstr "Algumas escolhas da enquete estão vazias"

#: src/components/compose.jsx:1063
msgid "Some media have no descriptions. Continue?"
msgstr "Algumas multimédias não possuem descrições. Prosseguir?"

#: src/components/compose.jsx:1115
msgid "Attachment #{i} failed"
msgstr "Anexo #{i} falhou"

#: src/components/compose.jsx:1211
#: src/components/status.jsx:2156
#: src/components/timeline.jsx:1017
msgid "Content warning"
msgstr "Alerta de conteúdo"

#: src/components/compose.jsx:1227
msgid "Content warning or sensitive media"
msgstr "Alerta de conteúdo ou multimédia sensível"

#: src/components/compose.jsx:1263
#: src/components/status.jsx:96
#: src/pages/settings.jsx:315
msgid "Public"
msgstr "Público"

#: src/components/compose.jsx:1268
#: src/components/nav-menu.jsx:344
#: src/components/shortcuts-settings.jsx:165
#: src/components/status.jsx:97
msgid "Local"
msgstr "Local"

#: src/components/compose.jsx:1272
#: src/components/status.jsx:98
#: src/pages/settings.jsx:318
msgid "Unlisted"
msgstr "Não listado"

#: src/components/compose.jsx:1275
#: src/components/status.jsx:99
#: src/pages/settings.jsx:321
msgid "Followers only"
msgstr "Somente seguidores"

#: src/components/compose.jsx:1278
#: src/components/status.jsx:100
#: src/components/status.jsx:2032
msgid "Private mention"
msgstr "Menção privada"

#: src/components/compose.jsx:1287
msgid "Post your reply"
msgstr "Publicar resposta"

#: src/components/compose.jsx:1289
msgid "Edit your post"
msgstr "Editar publicação"

#: src/components/compose.jsx:1290
msgid "What are you doing?"
msgstr "O que faz?"

#: src/components/compose.jsx:1368
msgid "Mark media as sensitive"
msgstr "Marcar multimédia como sensível"

#: src/components/compose.jsx:1405
msgid "Posting on <0/>"
msgstr "A publicar <0/>"

#: src/components/compose.jsx:1436
#: src/components/compose.jsx:3260
#: src/components/shortcuts-settings.jsx:715
#: src/pages/list.jsx:362
msgid "Add"
msgstr "Adicionar"

#: src/components/compose.jsx:1662
msgid "Schedule"
msgstr "Programar"

#: src/components/compose.jsx:1664
#: src/components/keyboard-shortcuts-help.jsx:155
#: src/components/status.jsx:1025
#: src/components/status.jsx:1806
#: src/components/status.jsx:1807
#: src/components/status.jsx:2492
msgid "Reply"
msgstr "Responder"

#: src/components/compose.jsx:1666
msgid "Update"
msgstr "Atualizar"

#: src/components/compose.jsx:1667
msgctxt "Submit button in composer"
msgid "Post"
msgstr "Publicar"

#: src/components/compose.jsx:1789
msgid "Downloading GIF…"
msgstr "A transferir GIF…"

#: src/components/compose.jsx:1817
msgid "Failed to download GIF"
msgstr "Falhou ao transferir GIF"

#: src/components/compose.jsx:2032
#: src/components/compose.jsx:2109
#: src/components/nav-menu.jsx:239
msgid "More…"
msgstr "Mais…"

#: src/components/compose.jsx:2541
msgid "Uploaded"
msgstr "Enviado"

#: src/components/compose.jsx:2554
msgid "Image description"
msgstr "Descrição da imagem"

#: src/components/compose.jsx:2555
msgid "Video description"
msgstr "Descrição do vídeo"

#: src/components/compose.jsx:2556
msgid "Audio description"
msgstr "Descrição do áudio"

#. placeholder {0}: prettyBytes( imageSize, )
#. placeholder {0}: prettyBytes( videoSize, )
#. placeholder {1}: prettyBytes(imageSizeLimit)
#. placeholder {1}: prettyBytes(videoSizeLimit)
#: src/components/compose.jsx:2592
#: src/components/compose.jsx:2612
msgid "File size too large. Uploading might encounter issues. Try reduce the file size from {0} to {1} or lower."
msgstr "O ficheiro é muito grande. Ao enviar pode enfrentar problemas. Tenta reduzir o tamanho de {0} a {1} ou mais baixo."

#. placeholder {0}: i18n.number( width, )
#. placeholder {1}: i18n.number(height)
#. placeholder {2}: i18n.number(newWidth)
#. placeholder {3}: i18n.number( newHeight, )
#: src/components/compose.jsx:2604
#: src/components/compose.jsx:2624
msgid "Dimension too large. Uploading might encounter issues. Try reduce dimension from {0}×{1}px to {2}×{3}px."
msgstr "A dimensão é muito grande. Ao enviar pode enfrentar problemas. Tenta reduzir a dimensão de {0}×{1}px para {2}×{3}px."

#: src/components/compose.jsx:2632
msgid "Frame rate too high. Uploading might encounter issues."
msgstr "A taxa de quadros está muito alta. Ao enviar pode enfrentar problemas."

#: src/components/compose.jsx:2692
#: src/components/compose.jsx:2942
#: src/components/shortcuts-settings.jsx:726
#: src/pages/catchup.jsx:1080
#: src/pages/filters.jsx:413
msgid "Remove"
msgstr "Eliminar"

#: src/components/compose.jsx:2709
#: src/compose.jsx:84
msgid "Error"
msgstr "Erro"

#: src/components/compose.jsx:2734
msgid "Edit image description"
msgstr "Editar descrição da imagem"

#: src/components/compose.jsx:2735
msgid "Edit video description"
msgstr "Editar descrição do vídeo"

#: src/components/compose.jsx:2736
msgid "Edit audio description"
msgstr "Editar descrição do áudio"

#: src/components/compose.jsx:2781
#: src/components/compose.jsx:2830
msgid "Generating description. Please wait…"
msgstr "A gerar descrição. Por favor, espere…"

#. placeholder {0}: e.message
#: src/components/compose.jsx:2801
msgid "Failed to generate description: {0}"
msgstr "Falhou ao gerar descrição: {0}"

#: src/components/compose.jsx:2802
msgid "Failed to generate description"
msgstr "Falhou ao gerar descrição"

#: src/components/compose.jsx:2814
#: src/components/compose.jsx:2820
#: src/components/compose.jsx:2866
msgid "Generate description…"
msgstr "Gerar descrição…"

#. placeholder {0}: e?.message ? `: ${e.message}` : ''
#: src/components/compose.jsx:2853
msgid "Failed to generate description{0}"
msgstr "Falhou ao gerar descrição{0}"

#. placeholder {0}: localeCode2Text(lang)
#: src/components/compose.jsx:2868
msgid "({0}) <0>— experimental</0>"
msgstr "({0}) <0>— experimental</0>"

#: src/components/compose.jsx:2887
msgid "Done"
msgstr "Concluído"

#. placeholder {0}: i + 1
#: src/components/compose.jsx:2923
msgid "Choice {0}"
msgstr "Escolha {0}"

#: src/components/compose.jsx:2970
msgid "Multiple choices"
msgstr "Várias escolhas"

#: src/components/compose.jsx:2973
msgid "Duration"
msgstr "Duração"

#: src/components/compose.jsx:3004
msgid "Remove poll"
msgstr "Eliminar enquete"

#: src/components/compose.jsx:3219
msgid "Search accounts"
msgstr "Buscar contas"

#: src/components/compose.jsx:3273
#: src/components/generic-accounts.jsx:228
msgid "Error loading accounts"
msgstr "Erro ao carregar contas"

#: src/components/compose.jsx:3417
msgid "Custom emojis"
msgstr "Emojis personalizados"

#: src/components/compose.jsx:3437
msgid "Search emoji"
msgstr "Buscar emoji"

#: src/components/compose.jsx:3468
msgid "Error loading custom emojis"
msgstr "Erro ao carregar emojis personalizados"

#: src/components/compose.jsx:3479
msgid "Recently used"
msgstr "Usado recentemente"

#: src/components/compose.jsx:3480
msgid "Others"
msgstr "Outros"

#. placeholder {0}: i18n.number(emojis.length - max)
#: src/components/compose.jsx:3518
msgid "{0} more…"
msgstr "{0} mais…"

#: src/components/compose.jsx:3656
msgid "Search GIFs"
msgstr "Buscar GIFs"

#: src/components/compose.jsx:3671
msgid "Powered by GIPHY"
msgstr "Desenvolvido por GIPHY"

#: src/components/compose.jsx:3679
msgid "Type to search GIFs"
msgstr "Digite para buscar GIFs"

#: src/components/compose.jsx:3777
#: src/components/media-modal.jsx:464
#: src/components/timeline.jsx:921
msgid "Previous"
msgstr "Anterior"

#: src/components/compose.jsx:3795
#: src/components/media-modal.jsx:483
#: src/components/timeline.jsx:938
msgid "Next"
msgstr "Seguinte"

#: src/components/compose.jsx:3812
msgid "Error loading GIFs"
msgstr "Erro ao carregar GIFs"

#: src/components/drafts.jsx:64
#: src/pages/settings.jsx:701
msgid "Unsent drafts"
msgstr "Rascunhos não enviados"

#: src/components/drafts.jsx:69
msgid "Looks like you have unsent drafts. Let's continue where you left off."
msgstr "Parece que tem rascunhos não enviados. Vamos continuar onde paraste."

#: src/components/drafts.jsx:103
msgid "Delete this draft?"
msgstr "Eliminar rascunho?"

#: src/components/drafts.jsx:118
msgid "Error deleting draft! Please try again."
msgstr "Erro ao eliminar rascunho. Tente novamente."

#: src/components/drafts.jsx:128
#: src/components/list-add-edit.jsx:186
#: src/components/status.jsx:1428
#: src/pages/filters.jsx:603
#: src/pages/scheduled-posts.jsx:367
msgid "Delete…"
msgstr "Eliminar…"

#: src/components/drafts.jsx:147
msgid "Error fetching reply-to status!"
msgstr "Erro ao obter estado de resposta!"

#: src/components/drafts.jsx:172
msgid "Delete all drafts?"
msgstr "Eliminar rascunhos?"

#: src/components/drafts.jsx:190
msgid "Error deleting drafts! Please try again."
msgstr "Erro ao eliminar rascunhos. Tente novamente."

#: src/components/drafts.jsx:202
msgid "Delete all…"
msgstr "Eliminar tudo…"

#: src/components/drafts.jsx:210
msgid "No drafts found."
msgstr "Nenhum rascunho encontrado."

#: src/components/drafts.jsx:247
#: src/pages/catchup.jsx:1933
msgid "Poll"
msgstr "Enquete"

#: src/components/drafts.jsx:250
#: src/pages/account-statuses.jsx:360
msgid "Media"
msgstr "Multimédia"

#: src/components/embed-modal.jsx:18
msgid "Open in new window"
msgstr "Abrir em nova janela"

#: src/components/follow-request-buttons.jsx:43
#: src/pages/notifications.jsx:984
msgid "Accept"
msgstr "Aceitar"

#: src/components/follow-request-buttons.jsx:69
msgid "Reject"
msgstr "Rejeitar"

#: src/components/follow-request-buttons.jsx:76
#: src/pages/notifications.jsx:1268
msgid "Accepted"
msgstr "Aceitado"

#: src/components/follow-request-buttons.jsx:80
msgid "Rejected"
msgstr "Rejeitado"

#: src/components/generic-accounts.jsx:146
#: src/components/notification.jsx:445
#: src/pages/accounts.jsx:42
#: src/pages/search.jsx:331
#: src/pages/search.jsx:364
msgid "Accounts"
msgstr "Contas"

#: src/components/generic-accounts.jsx:206
#: src/components/timeline.jsx:545
#: src/pages/list.jsx:295
#: src/pages/notifications.jsx:914
#: src/pages/search.jsx:558
#: src/pages/status.jsx:1352
msgid "Show more…"
msgstr "Mostrar mais…"

#: src/components/generic-accounts.jsx:211
#: src/components/timeline.jsx:550
#: src/pages/search.jsx:563
msgid "The end."
msgstr "Fim."

#: src/components/generic-accounts.jsx:232
msgid "Nothing to show"
msgstr "Nada para exibir"

#: src/components/keyboard-shortcuts-help.jsx:47
#: src/components/nav-menu.jsx:363
#: src/pages/catchup.jsx:1621
msgid "Keyboard shortcuts"
msgstr "Atalhos do teclado"

#: src/components/keyboard-shortcuts-help.jsx:55
msgid "Keyboard shortcuts help"
msgstr "Ajuda com atalhos do teclado"

#: src/components/keyboard-shortcuts-help.jsx:59
#: src/pages/catchup.jsx:1646
msgid "Next post"
msgstr "Publicação seguinte"

#: src/components/keyboard-shortcuts-help.jsx:63
#: src/pages/catchup.jsx:1654
msgid "Previous post"
msgstr "Publicação anterior"

#: src/components/keyboard-shortcuts-help.jsx:67
msgid "Skip carousel to next post"
msgstr "Pular carrossel para a publicação seguinte"

#: src/components/keyboard-shortcuts-help.jsx:69
msgid "<0>Shift</0> + <1>j</1>"
msgstr "<0>Shift</0> + <1>j</1>"

#: src/components/keyboard-shortcuts-help.jsx:75
msgid "Skip carousel to previous post"
msgstr "Pular carrossel para a publicação anterior"

#: src/components/keyboard-shortcuts-help.jsx:77
msgid "<0>Shift</0> + <1>k</1>"
msgstr "<0>Shift</0> + <1>k</1>"

#: src/components/keyboard-shortcuts-help.jsx:83
msgid "Load new posts"
msgstr "Ver novas postagens"

#: src/components/keyboard-shortcuts-help.jsx:87
#: src/pages/catchup.jsx:1678
msgid "Open post details"
msgstr "Abrir detalhes da publicação"

#: src/components/keyboard-shortcuts-help.jsx:89
msgid "<0>Enter</0> or <1>o</1>"
msgstr "<0>Enter</0> ou <1>o</1>"

#: src/components/keyboard-shortcuts-help.jsx:96
msgid "Expand content warning or<0/>toggle expanded/collapsed thread"
msgstr "Expandir alerta de conteúdo ou<0/>alternar tópico expandido/colapsado"

#: src/components/keyboard-shortcuts-help.jsx:105
msgid "Close post or dialogs"
msgstr "Fechar publicação ou diálogos"

#: src/components/keyboard-shortcuts-help.jsx:107
msgid "<0>Esc</0> or <1>Backspace</1>"
msgstr "<0>Esc</0> ou <1>Backspace</1>"

#: src/components/keyboard-shortcuts-help.jsx:113
msgid "Focus column in multi-column mode"
msgstr "Focar coluna no modo multi-coluna"

#: src/components/keyboard-shortcuts-help.jsx:115
msgid "<0>1</0> to <1>9</1>"
msgstr "<0>1</0> a <1>9</1>"

#: src/components/keyboard-shortcuts-help.jsx:121
msgid "Focus next column in multi-column mode"
msgstr "Focar na próxima coluna no modo multi-coluna"

#: src/components/keyboard-shortcuts-help.jsx:125
msgid "Focus previous column in multi-column mode"
msgstr "Focar na coluna anterior no modo multi-coluna"

#: src/components/keyboard-shortcuts-help.jsx:129
msgid "Compose new post"
msgstr "Escrever nova publicação"

#: src/components/keyboard-shortcuts-help.jsx:133
msgid "Compose new post (new window)"
msgstr "Escrever nova publicação (nova janela)"

#: src/components/keyboard-shortcuts-help.jsx:136
msgid "<0>Shift</0> + <1>c</1>"
msgstr "<0>Shift</0> + <1>c</1>"

#: src/components/keyboard-shortcuts-help.jsx:142
msgid "Send post"
msgstr "Enviar publicação"

#: src/components/keyboard-shortcuts-help.jsx:144
msgid "<0>Ctrl</0> + <1>Enter</1> or <2>⌘</2> + <3>Enter</3>"
msgstr "<0>Ctrl</0> + <1>Enter</1> ou <2>⌘</2> + <3>Enter</3>"

#: src/components/keyboard-shortcuts-help.jsx:151
#: src/components/nav-menu.jsx:332
#: src/components/search-form.jsx:73
#: src/components/shortcuts-settings.jsx:52
#: src/components/shortcuts-settings.jsx:179
#: src/pages/search.jsx:46
#: src/pages/search.jsx:313
msgid "Search"
msgstr "Buscar"

#: src/components/keyboard-shortcuts-help.jsx:159
msgid "Reply (new window)"
msgstr "Responder (nova janela)"

#: src/components/keyboard-shortcuts-help.jsx:162
msgid "<0>Shift</0> + <1>r</1>"
msgstr "<0>Shift</0> + <1>r</1>"

#: src/components/keyboard-shortcuts-help.jsx:168
msgid "Like (favourite)"
msgstr "Gosto (favorito)"

#: src/components/keyboard-shortcuts-help.jsx:170
msgid "<0>l</0> or <1>f</1>"
msgstr "<0>l</0> ou <1>f</1>"

#: src/components/keyboard-shortcuts-help.jsx:176
#: src/components/status.jsx:1033
#: src/components/status.jsx:2519
#: src/components/status.jsx:2542
#: src/components/status.jsx:2543
msgid "Boost"
msgstr "Impulsionar"

#: src/components/keyboard-shortcuts-help.jsx:178
msgid "<0>Shift</0> + <1>b</1>"
msgstr "<0>Shift</0> + <1>b</1>"

#: src/components/keyboard-shortcuts-help.jsx:184
#: src/components/status.jsx:1096
#: src/components/status.jsx:2567
#: src/components/status.jsx:2568
msgid "Bookmark"
msgstr "Marcar como favorito"

#: src/components/keyboard-shortcuts-help.jsx:188
msgid "Toggle Cloak mode"
msgstr "Alternar modo oculto"

#: src/components/keyboard-shortcuts-help.jsx:190
msgid "<0>Shift</0> + <1>Alt</1> + <2>k</2>"
msgstr "<0>Shift</0> + <1>Alt</1> + <2>k</2>"

#: src/components/list-add-edit.jsx:40
msgid "Edit list"
msgstr "Editar lista"

#: src/components/list-add-edit.jsx:96
msgid "Unable to edit list."
msgstr "Impossível editar lista."

#: src/components/list-add-edit.jsx:97
msgid "Unable to create list."
msgstr "Impossível criar lista."

#: src/components/list-add-edit.jsx:125
msgid "Show replies to list members"
msgstr "Mostrar respostas aos membros da lista"

#: src/components/list-add-edit.jsx:128
msgid "Show replies to people I follow"
msgstr "Mostrar respostas para quem sigo"

#: src/components/list-add-edit.jsx:131
msgid "Don't show replies"
msgstr "Não mostrar respostas"

#: src/components/list-add-edit.jsx:144
msgid "Hide posts on this list from Home/Following"
msgstr "Ocultar postagens nesta lista da página inicial/A seguir"

#: src/components/list-add-edit.jsx:150
#: src/pages/filters.jsx:570
msgid "Create"
msgstr "Criar"

#: src/components/list-add-edit.jsx:157
msgid "Delete this list?"
msgstr "Eliminar lista?"

#: src/components/list-add-edit.jsx:176
msgid "Unable to delete list."
msgstr "Impossível eliminar lista."

#: src/components/media-alt-modal.jsx:39
#: src/components/media.jsx:51
msgid "Media description"
msgstr "Descrição da multimédia"

#: src/components/media-alt-modal.jsx:58
#: src/components/status.jsx:1139
#: src/components/status.jsx:1148
#: src/components/translation-block.jsx:235
msgid "Translate"
msgstr "Traduzir"

#: src/components/media-alt-modal.jsx:69
#: src/components/status.jsx:1167
msgid "Speak"
msgstr "Falar"

#: src/components/media-modal.jsx:369
msgid "Open original media in new window"
msgstr "Abrir multimédia original em nova janela"

#: src/components/media-modal.jsx:373
msgid "Open original media"
msgstr "Abrir multimédia original"

#: src/components/media-modal.jsx:389
msgid "Attempting to describe image. Please wait…"
msgstr "A descrever imagem. Por favor, espere…"

#: src/components/media-modal.jsx:404
msgid "Failed to describe image"
msgstr "Falhou ao descrever imagem"

#: src/components/media-modal.jsx:414
msgid "Describe image…"
msgstr "Descrever imagem…"

#: src/components/media-modal.jsx:438
msgid "View post"
msgstr "Ver publicação"

#: src/components/media-post.jsx:128
msgid "Sensitive media"
msgstr "Multimédia sensível"

#: src/components/media-post.jsx:133
msgid "Filtered: {filterTitleStr}"
msgstr "Filtrado: {filterTitleStr}"

#: src/components/media-post.jsx:134
#: src/components/status.jsx:3662
#: src/components/status.jsx:3758
#: src/components/status.jsx:3836
#: src/components/timeline.jsx:1006
#: src/pages/catchup.jsx:76
#: src/pages/catchup.jsx:1881
msgid "Filtered"
msgstr "Filtrado"

#: src/components/media.jsx:417
msgid "Open file"
msgstr "Abrir ficheiro"

#: src/components/modals.jsx:75
msgid "Post scheduled"
msgstr "Publicação programada"

#: src/components/modals.jsx:76
msgid "Post published. Check it out."
msgstr "Publicado. Dê uma olhada."

#: src/components/modals.jsx:78
msgid "Reply scheduled"
msgstr "Resposta programada"

#: src/components/modals.jsx:79
msgid "Reply posted. Check it out."
msgstr "Resposta publicada. Dê uma olhada."

#: src/components/modals.jsx:80
msgid "Post updated. Check it out."
msgstr "Publicação atualizada. Dê uma olhada."

#: src/components/nav-menu.jsx:118
msgid "Menu"
msgstr "Menu"

#: src/components/nav-menu.jsx:154
msgid "Reload page now to update?"
msgstr "Recarregar página para atualizar?"

#: src/components/nav-menu.jsx:166
msgid "New update available…"
msgstr "Nova atualização disponível…"

#. js-lingui-explicit-id
#: src/components/nav-menu.jsx:185
#: src/components/shortcuts-settings.jsx:140
#: src/pages/following.jsx:23
#: src/pages/following.jsx:142
msgid "following.title"
msgstr "A seguir"

#: src/components/nav-menu.jsx:192
#: src/pages/catchup.jsx:877
msgid "Catch-up"
msgstr "Acompanhar"

#: src/components/nav-menu.jsx:199
#: src/components/shortcuts-settings.jsx:58
#: src/components/shortcuts-settings.jsx:146
#: src/pages/home.jsx:228
#: src/pages/mentions.jsx:21
#: src/pages/mentions.jsx:168
#: src/pages/settings.jsx:1151
#: src/pages/trending.jsx:379
msgid "Mentions"
msgstr "Menções"

#: src/components/nav-menu.jsx:206
#: src/components/shortcuts-settings.jsx:49
#: src/components/shortcuts-settings.jsx:152
#: src/pages/filters.jsx:24
#: src/pages/home.jsx:86
#: src/pages/home.jsx:186
#: src/pages/notifications.jsx:114
#: src/pages/notifications.jsx:583
msgid "Notifications"
msgstr "Notificações"

#: src/components/nav-menu.jsx:209
msgid "New"
msgstr "Novo"

#: src/components/nav-menu.jsx:220
msgid "Profile"
msgstr "Perfil"

#: src/components/nav-menu.jsx:228
#: src/components/shortcuts-settings.jsx:54
#: src/components/shortcuts-settings.jsx:195
#: src/pages/bookmarks.jsx:12
#: src/pages/bookmarks.jsx:24
msgid "Bookmarks"
msgstr "Favoritos"

#: src/components/nav-menu.jsx:248
#: src/components/shortcuts-settings.jsx:55
#: src/components/shortcuts-settings.jsx:201
#: src/pages/catchup.jsx:1448
#: src/pages/catchup.jsx:2068
#: src/pages/favourites.jsx:12
#: src/pages/favourites.jsx:24
#: src/pages/settings.jsx:1155
msgid "Likes"
msgstr "Gostos"

#: src/components/nav-menu.jsx:254
#: src/pages/followed-hashtags.jsx:15
#: src/pages/followed-hashtags.jsx:45
msgid "Followed Hashtags"
msgstr "Hashtags seguidas"

#: src/components/nav-menu.jsx:268
#: src/pages/account-statuses.jsx:326
#: src/pages/filters.jsx:55
#: src/pages/filters.jsx:94
#: src/pages/hashtag.jsx:340
msgid "Filters"
msgstr "Filtros"

#: src/components/nav-menu.jsx:276
msgid "Muted users"
msgstr "Utilizadores silenciados"

#: src/components/nav-menu.jsx:284
msgid "Muted users…"
msgstr "Utilizadores silenciados…"

#: src/components/nav-menu.jsx:291
msgid "Blocked users"
msgstr "Utilizadores bloqueados"

#: src/components/nav-menu.jsx:299
msgid "Blocked users…"
msgstr "Utilizadores bloqueados…"

#: src/components/nav-menu.jsx:311
msgid "Accounts…"
msgstr "Contas…"

#: src/components/nav-menu.jsx:321
#: src/pages/login.jsx:27
#: src/pages/login.jsx:190
#: src/pages/status.jsx:855
#: src/pages/welcome.jsx:65
msgid "Log in"
msgstr "Iniciar sessão"

#: src/components/nav-menu.jsx:338
#: src/components/shortcuts-settings.jsx:57
#: src/components/shortcuts-settings.jsx:172
#: src/pages/trending.jsx:439
msgid "Trending"
msgstr "Tendência"

#: src/components/nav-menu.jsx:350
#: src/components/shortcuts-settings.jsx:165
msgid "Federated"
msgstr "Federado"

#: src/components/nav-menu.jsx:373
msgid "Shortcuts / Columns…"
msgstr "Atalhos / Colunas…"

#: src/components/nav-menu.jsx:383
#: src/components/nav-menu.jsx:397
msgid "Settings…"
msgstr "Definições…"

#: src/components/nav-menu.jsx:427
#: src/components/nav-menu.jsx:454
#: src/components/shortcuts-settings.jsx:50
#: src/components/shortcuts-settings.jsx:158
#: src/pages/list.jsx:127
#: src/pages/lists.jsx:17
#: src/pages/lists.jsx:51
msgid "Lists"
msgstr "Listas"

#: src/components/nav-menu.jsx:435
#: src/components/shortcuts.jsx:214
#: src/pages/list.jsx:134
msgid "All Lists"
msgstr "Todas as listas"

#: src/components/notification-service.jsx:161
msgid "Notification"
msgstr "Notificação"

#: src/components/notification-service.jsx:167
msgid "This notification is from your other account."
msgstr "Esta notificação é da sua outra conta."

#: src/components/notification-service.jsx:196
msgid "View all notifications"
msgstr "Ver todas as notificações"

#: src/components/notification.jsx:71
msgid "{account} reacted to your post with {emojiObject}"
msgstr "{account} reagiu a sua publicação com {emojiObject}"

#: src/components/notification.jsx:78
msgid "{account} published a post."
msgstr "{account} fez uma publicação."

#. placeholder {0}: shortenNumber(count)
#. placeholder {1}: shortenNumber(count)
#: src/components/notification.jsx:86
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} boosted your reply.} other {{account} boosted your post.}}} other {{account} boosted {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> boosted your reply.} other {<2><3>{1}</3> people</2> boosted your post.}}}}"
msgstr "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} impulsionou a sua resposta.} other {{account} impulsionou a sua postagem.}}} other {{account} impulsionou {postsCount} das suas postagens.}}} other {{postType, select, reply {<0><1>{0}</1> pessoa(s)</0> impulsionou a sua resposta.} other {<2><3>{1}</3> pessoa(s)</2> impulsionou a sua postagem.}}}}"

#. placeholder {0}: shortenNumber(count)
#: src/components/notification.jsx:129
msgid "{count, plural, =1 {{account} followed you.} other {<0><1>{0}</1> people</0> followed you.}}"
msgstr "{count, plural, =1 {{account} seguiu você.} other {<0><1>{0}</1> pessoa(s)</0> seguiu você.}}"

#: src/components/notification.jsx:143
msgid "{account} requested to follow you."
msgstr "{account} pediu para seguir-te."

#. placeholder {0}: shortenNumber(count)
#. placeholder {1}: shortenNumber(count)
#: src/components/notification.jsx:152
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} liked your reply.} other {{account} liked your post.}}} other {{account} liked {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> liked your reply.} other {<2><3>{1}</3> people</2> liked your post.}}}}"
msgstr "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} gostou da sua resposta.} other {{account} gostou da sua postagem.}}} other {{account} gostou de {postsCount} das suas postagens.}}} other {{postType, select, reply {<0><1>{0}</1> pessoa(s)</0> gostou da sua resposta.} other {<2><3>{1}</3> pessoa(s)</2> gostou da sua postagens.}}}}"

#: src/components/notification.jsx:194
msgid "A poll you have voted in or created has ended."
msgstr "A enquete que votaste ou criaste já acabou."

#: src/components/notification.jsx:195
msgid "A poll you have created has ended."
msgstr "Uma enquete que criaste já acabou."

#: src/components/notification.jsx:196
msgid "A poll you have voted in has ended."
msgstr "Uma enquete que votaste já acabou."

#: src/components/notification.jsx:197
msgid "A post you interacted with has been edited."
msgstr "Uma publicação que interagiste foi editada."

#. placeholder {0}: shortenNumber(count)
#. placeholder {1}: shortenNumber(count)
#: src/components/notification.jsx:205
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} boosted & liked your reply.} other {{account} boosted & liked your post.}}} other {{account} boosted & liked {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> boosted & liked your reply.} other {<2><3>{1}</3> people</2> boosted & liked your post.}}}}"
msgstr "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} impulsionou e gostou da sua resposta.} other {{account} impulsionou e gostou da sua postagem.}}} other {{account} impulsionou e gostou de {postsCount} das suas postagens.}}} other {{postType, select, reply {<0><1>{0}</1> pessoa(s)</0> impulsionou e gostou da sua resposta.} other {<2><3>{1}</3> pessoa(s)</2> impulsionou e gostou da sua postagem.}}}}"

#: src/components/notification.jsx:247
msgid "{account} signed up."
msgstr "{account} registrada."

#: src/components/notification.jsx:249
msgid "{account} reported {targetAccount}"
msgstr "{account} reportou {targetAccount}"

#: src/components/notification.jsx:254
msgid "Lost connections with <0>{name}</0>."
msgstr "Perdeu conexões com <0>{name}</0>."

#: src/components/notification.jsx:260
msgid "Moderation warning"
msgstr "Aviso da moderação"

#: src/components/notification.jsx:265
msgid "Your {year} #Wrapstodon is here!"
msgstr "O seu #Wrapstodon {year} chegou!"

#: src/components/notification.jsx:271
msgid "An admin from <0>{from}</0> has suspended <1>{targetName}</1>, which means you can no longer receive updates from them or interact with them."
msgstr "Um administrador de <0>{from}</0> suspendeu <1>{targetName}</1>, significando que não receberá mais atualizações deles ou interagir com eles."

#: src/components/notification.jsx:277
msgid "An admin from <0>{from}</0> has blocked <1>{targetName}</1>. Affected followers: {followersCount}, followings: {followingCount}."
msgstr "Um administrador de <0>{from}</0> bloqueou <1>{targetName}</1>. Seguidores afetados: {followersCount}, a seguir: {followingCount}."

#: src/components/notification.jsx:283
msgid "You have blocked <0>{targetName}</0>. Removed followers: {followersCount}, followings: {followingCount}."
msgstr "Bloqueaste <0>{targetName}</0>.\n"
"Seguidores removidos: {followersCount}, a seguir: {followingCount}."

#: src/components/notification.jsx:291
msgid "Your account has received a moderation warning."
msgstr "A sua conta recebeu um aviso da moderação."

#: src/components/notification.jsx:292
msgid "Your account has been disabled."
msgstr "A sua conta foi desativada."

#: src/components/notification.jsx:293
msgid "Some of your posts have been marked as sensitive."
msgstr "Algumas das suas postagens foram marcados como sensíveis."

#: src/components/notification.jsx:294
msgid "Some of your posts have been deleted."
msgstr "Algumas das suas postagens foram eliminadas."

#: src/components/notification.jsx:295
msgid "Your posts will be marked as sensitive from now on."
msgstr "Agora as suas postagens serão marcadas como sensíveis."

#: src/components/notification.jsx:296
msgid "Your account has been limited."
msgstr "A sua conta foi limitada."

#: src/components/notification.jsx:297
msgid "Your account has been suspended."
msgstr "A sua conta foi suspensa."

#: src/components/notification.jsx:372
msgid "[Unknown notification type: {type}]"
msgstr "[Tipo de notificação desconhecida: {type}]"

#: src/components/notification.jsx:441
#: src/components/status.jsx:1110
#: src/components/status.jsx:1120
msgid "Boosted/Liked by…"
msgstr "Impulsionado/Gostado por…"

#: src/components/notification.jsx:442
msgid "Liked by…"
msgstr "Gostado por…"

#: src/components/notification.jsx:443
msgid "Boosted by…"
msgstr "Impulsionado por…"

#: src/components/notification.jsx:444
msgid "Followed by…"
msgstr "Seguido por…"

#: src/components/notification.jsx:514
#: src/components/notification.jsx:530
msgid "Learn more <0/>"
msgstr "Saiba mais <0/>"

#: src/components/notification.jsx:539
msgid "View #Wrapstodon"
msgstr "Ver #Wrapstodon"

#: src/components/notification.jsx:772
#: src/components/status.jsx:316
msgid "Read more →"
msgstr "Leia mais →"

#: src/components/poll.jsx:113
msgid "Voted"
msgstr "Votado"

#: src/components/poll.jsx:119
msgid "{optionVotesCount, plural, one {# vote} other {# votes}}"
msgstr "{optionVotesCount, plural, one {# voto} other {# votos}}"

#: src/components/poll.jsx:139
#: src/components/poll.jsx:222
#: src/components/poll.jsx:226
msgid "Hide results"
msgstr "Ocultar resultado"

#: src/components/poll.jsx:188
msgid "Vote"
msgstr "Votar"

#: src/components/poll.jsx:208
#: src/components/poll.jsx:210
#: src/pages/scheduled-posts.jsx:98
#: src/pages/status.jsx:1221
#: src/pages/status.jsx:1244
msgid "Refresh"
msgstr "Atualizar"

#: src/components/poll.jsx:222
#: src/components/poll.jsx:226
msgid "Show results"
msgstr "Mostrar resultado"

#. placeholder {0}: shortenNumber(votesCount)
#. placeholder {1}: shortenNumber(votesCount)
#: src/components/poll.jsx:231
msgid "{votesCount, plural, one {<0>{0}</0> vote} other {<1>{1}</1> votes}}"
msgstr "{votesCount, plural, one {<0>{0}</0> voto} other {<1>{1}</1> votos}}"

#. placeholder {0}: shortenNumber(votersCount)
#. placeholder {1}: shortenNumber(votersCount)
#: src/components/poll.jsx:248
msgid "{votersCount, plural, one {<0>{0}</0> voter} other {<1>{1}</1> voters}}"
msgstr "{votersCount, plural, one {<0>{0}</0> votante} other {<1>{1}</1> votantes}}"

#: src/components/poll.jsx:268
msgid "Ended <0/>"
msgstr "Acabou <0/>"

#: src/components/poll.jsx:272
msgid "Ended"
msgstr "Acabou"

#: src/components/poll.jsx:275
msgid "Ending <0/>"
msgstr "A acabar <0/>"

#: src/components/poll.jsx:279
msgid "Ending"
msgstr "A acabar"

#. Relative time in seconds, as short as possible
#. placeholder {0}: seconds < 1 ? 1 : Math.floor(seconds)
#: src/components/relative-time.jsx:59
msgid "{0}s"
msgstr "{0}s"

#. Relative time in minutes, as short as possible
#. placeholder {0}: Math.floor(seconds / minute)
#: src/components/relative-time.jsx:64
msgid "{0}m"
msgstr "{0}m"

#. Relative time in hours, as short as possible
#. placeholder {0}: Math.floor(seconds / hour)
#: src/components/relative-time.jsx:69
msgid "{0}h"
msgstr "{0}h"

#: src/components/report-modal.jsx:29
msgid "Spam"
msgstr "Spam"

#: src/components/report-modal.jsx:30
msgid "Malicious links, fake engagement, or repetitive replies"
msgstr "Ligações maliciosas, interações falsas ou respostas repetitivas"

#: src/components/report-modal.jsx:33
msgid "Illegal"
msgstr "Ilegal"

#: src/components/report-modal.jsx:34
msgid "Violates the law of your or the server's country"
msgstr "Viola a lei do seu ou do servidor"

#: src/components/report-modal.jsx:37
msgid "Server rule violation"
msgstr "Regra de violação do servidor"

#: src/components/report-modal.jsx:38
msgid "Breaks specific server rules"
msgstr "Quebra regras específicas do servidor"

#: src/components/report-modal.jsx:39
msgid "Violation"
msgstr "Violação"

#: src/components/report-modal.jsx:42
msgid "Other"
msgstr "Outro"

#: src/components/report-modal.jsx:43
msgid "Issue doesn't fit other categories"
msgstr "O problema não se encaixa em outras categorias"

#: src/components/report-modal.jsx:68
msgid "Report Post"
msgstr "Relatar publicação"

#: src/components/report-modal.jsx:68
msgid "Report @{username}"
msgstr "Relatar @{username}"

#: src/components/report-modal.jsx:104
msgid "Pending review"
msgstr "Revisão pendente"

#: src/components/report-modal.jsx:146
msgid "Post reported"
msgstr "Publicação relatada"

#: src/components/report-modal.jsx:146
msgid "Profile reported"
msgstr "Perfil relatado"

#: src/components/report-modal.jsx:154
msgid "Unable to report post"
msgstr "Impossível reportar publicação"

#: src/components/report-modal.jsx:155
msgid "Unable to report profile"
msgstr "Impossível reportar perfil"

#: src/components/report-modal.jsx:163
msgid "What's the issue with this post?"
msgstr "Qual é o problema com a publicação?"

#: src/components/report-modal.jsx:164
msgid "What's the issue with this profile?"
msgstr "Qual é o problema com o perfil?"

#: src/components/report-modal.jsx:233
msgid "Additional info"
msgstr "Informações adicionais"

#: src/components/report-modal.jsx:256
msgid "Forward to <0>{domain}</0>"
msgstr "Encaminhar para <0>{domain}</0>"

#: src/components/report-modal.jsx:266
msgid "Send Report"
msgstr "Enviar relato"

#: src/components/report-modal.jsx:275
msgid "Muted {username}"
msgstr "Silenciou {username}"

#: src/components/report-modal.jsx:278
msgid "Unable to mute {username}"
msgstr "Impossível silenciar {username}"

#: src/components/report-modal.jsx:283
msgid "Send Report <0>+ Mute profile</0>"
msgstr "Enviar relato <0>+ Silenciar perfil</0>"

#: src/components/report-modal.jsx:294
msgid "Blocked {username}"
msgstr "Bloqueou {username}"

#: src/components/report-modal.jsx:297
msgid "Unable to block {username}"
msgstr "Impossível bloquear {username}"

#: src/components/report-modal.jsx:302
msgid "Send Report <0>+ Block profile</0>"
msgstr "Enviar relato <0>+ Bloquear perfil</0>"

#: src/components/search-form.jsx:203
msgid "{query} <0>‒ accounts, hashtags & posts</0>"
msgstr "{query} <0>‒ contas, hashtags e postagens</0>"

#: src/components/search-form.jsx:216
msgid "Posts with <0>{query}</0>"
msgstr "Publicações com <0>{query}</0>"

#. placeholder {0}: query.replace(/^#/, '')
#: src/components/search-form.jsx:228
msgid "Posts tagged with <0>#{0}</0>"
msgstr "Publicações marcadas com <0>#{0}</0>"

#: src/components/search-form.jsx:242
msgid "Look up <0>{query}</0>"
msgstr "Buscar <0>{query}</0>"

#: src/components/search-form.jsx:253
msgid "Accounts with <0>{query}</0>"
msgstr "Contas com <0>{query}</0>"

#: src/components/shortcuts-settings.jsx:48
msgid "Home / Following"
msgstr "Página inicial / A seguir"

#: src/components/shortcuts-settings.jsx:51
msgid "Public (Local / Federated)"
msgstr "Público (Local / Federado)"

#: src/components/shortcuts-settings.jsx:53
msgid "Account"
msgstr "Conta"

#: src/components/shortcuts-settings.jsx:56
msgid "Hashtag"
msgstr "Hashtag"

#: src/components/shortcuts-settings.jsx:63
msgid "List ID"
msgstr "ID de lista"

#: src/components/shortcuts-settings.jsx:70
msgid "Local only"
msgstr "Apenas local"

#: src/components/shortcuts-settings.jsx:75
#: src/components/shortcuts-settings.jsx:84
#: src/components/shortcuts-settings.jsx:122
#: src/pages/login.jsx:194
msgid "Instance"
msgstr "Instância"

#: src/components/shortcuts-settings.jsx:78
#: src/components/shortcuts-settings.jsx:87
#: src/components/shortcuts-settings.jsx:125
msgid "Optional, e.g. mastodon.social"
msgstr "Opcional, ex.: mastodon.social"

#: src/components/shortcuts-settings.jsx:93
msgid "Search term"
msgstr "Buscar termo"

#: src/components/shortcuts-settings.jsx:96
msgid "Optional, unless for multi-column mode"
msgstr "Opcional, menos para o modo multi-coluna"

#: src/components/shortcuts-settings.jsx:113
msgid "e.g. PixelArt (Max 5, space-separated)"
msgstr "ex.: PixelArt (Máx. 5, espaço separado)"

#: src/components/shortcuts-settings.jsx:117
#: src/pages/hashtag.jsx:356
msgid "Media only"
msgstr "Somente multimédia"

#: src/components/shortcuts-settings.jsx:235
#: src/components/shortcuts.jsx:191
msgid "Shortcuts"
msgstr "Atalhos"

#: src/components/shortcuts-settings.jsx:243
msgid "beta"
msgstr "beta"

#: src/components/shortcuts-settings.jsx:249
msgid "Specify a list of shortcuts that'll appear as:"
msgstr "Especifique uma lista de atalhos que aparecerá como:"

#: src/components/shortcuts-settings.jsx:255
msgid "Floating button"
msgstr "Botão flutuante"

#: src/components/shortcuts-settings.jsx:260
msgid "Tab/Menu bar"
msgstr "Aba/Barra do menu"

#: src/components/shortcuts-settings.jsx:265
msgid "Multi-column"
msgstr "Multi-coluna"

#: src/components/shortcuts-settings.jsx:332
msgid "Not available in current view mode"
msgstr "Indisponível no modo de visualização atual"

#: src/components/shortcuts-settings.jsx:351
msgid "Move up"
msgstr "Mover para cima"

#: src/components/shortcuts-settings.jsx:367
msgid "Move down"
msgstr "Mover para baixo"

#: src/components/shortcuts-settings.jsx:379
#: src/components/status.jsx:1390
#: src/pages/list.jsx:171
msgid "Edit"
msgstr "Editar"

#: src/components/shortcuts-settings.jsx:400
msgid "Add more than one shortcut/column to make this work."
msgstr "Adicione mais de um atalho/coluna para fazer funcionar."

#: src/components/shortcuts-settings.jsx:411
msgid "No columns yet. Tap on the Add column button."
msgstr "Nenhuma coluna ainda. Clique no botão de adicionar coluna."

#: src/components/shortcuts-settings.jsx:412
msgid "No shortcuts yet. Tap on the Add shortcut button."
msgstr "Nenhum atalho ainda. Clique no botão de adicionar atalho."

#: src/components/shortcuts-settings.jsx:415
msgid "Not sure what to add?<0/>Try adding <1>Home / Following and Notifications</1> first."
msgstr "Sem certeza do que adicionar?<0/>Tente adicionar as <1>Notificações da Página Inicial / A seguir</1> primeiramente."

#: src/components/shortcuts-settings.jsx:443
msgid "Max {SHORTCUTS_LIMIT} columns"
msgstr "Máximo {SHORTCUTS_LIMIT} colunas"

#: src/components/shortcuts-settings.jsx:444
msgid "Max {SHORTCUTS_LIMIT} shortcuts"
msgstr "Máximo {SHORTCUTS_LIMIT} atalhos"

#: src/components/shortcuts-settings.jsx:458
msgid "Import/export"
msgstr "Importar/Exportar"

#: src/components/shortcuts-settings.jsx:468
msgid "Add column…"
msgstr "Adicionar coluna…"

#: src/components/shortcuts-settings.jsx:469
msgid "Add shortcut…"
msgstr "Adicionar atalho…"

#: src/components/shortcuts-settings.jsx:516
msgid "Specific list is optional. For multi-column mode, list is required, else the column will not be shown."
msgstr "A lista específica é opcional. Para o modo multi-coluna a lista é necessária, ou a coluna não será exibida."

#: src/components/shortcuts-settings.jsx:517
msgid "For multi-column mode, search term is required, else the column will not be shown."
msgstr "Para o modo multi-coluna, buscar o termo é necessário ou a coluna não será exibida."

#: src/components/shortcuts-settings.jsx:518
msgid "Multiple hashtags are supported. Space-separated."
msgstr "Várias hashtags são suportadas. Separado por espaço."

#: src/components/shortcuts-settings.jsx:587
msgid "Edit shortcut"
msgstr "Editar atalho"

#: src/components/shortcuts-settings.jsx:587
msgid "Add shortcut"
msgstr "Adicionar atalho"

#: src/components/shortcuts-settings.jsx:623
msgid "Timeline"
msgstr "Linha do tempo"

#: src/components/shortcuts-settings.jsx:649
msgid "List"
msgstr "Lista"

#: src/components/shortcuts-settings.jsx:788
msgid "Import/Export <0>Shortcuts</0>"
msgstr "Importar/Exportar <0>atalhos</0>"

#: src/components/shortcuts-settings.jsx:798
msgid "Import"
msgstr "Importar"

#: src/components/shortcuts-settings.jsx:806
msgid "Paste shortcuts here"
msgstr "Cole atalhos aqui"

#: src/components/shortcuts-settings.jsx:822
msgid "Downloading saved shortcuts from instance server…"
msgstr "A transferir atalhos guardados do servidor de instância…"

#: src/components/shortcuts-settings.jsx:851
msgid "Unable to download shortcuts"
msgstr "Impossível transferir atalhos"

#: src/components/shortcuts-settings.jsx:854
msgid "Download shortcuts from instance server"
msgstr "Transferir atalhos do servidor de instância"

#: src/components/shortcuts-settings.jsx:912
msgid "* Exists in current shortcuts"
msgstr "* Existem nos atuais atalhos"

#: src/components/shortcuts-settings.jsx:917
msgid "List may not work if it's from a different account."
msgstr "A lista pode não funcionar se for de uma conta diferente."

#: src/components/shortcuts-settings.jsx:927
msgid "Invalid settings format"
msgstr "Formato de definições inválida"

#: src/components/shortcuts-settings.jsx:935
msgid "Append to current shortcuts?"
msgstr "Anexar aos atalhos atuais?"

#: src/components/shortcuts-settings.jsx:938
msgid "Only shortcuts that don’t exist in current shortcuts will be appended."
msgstr "Apenas atalhos que não existem no atalho atual serão anexados."

#: src/components/shortcuts-settings.jsx:960
msgid "No new shortcuts to import"
msgstr "Nenhum atalho novo para importar"

#: src/components/shortcuts-settings.jsx:975
msgid "Shortcuts imported. Exceeded max {SHORTCUTS_LIMIT}, so the rest are not imported."
msgstr "Atalhos importados. Máximo excedido {SHORTCUTS_LIMIT}, então o resto não será importado."

#: src/components/shortcuts-settings.jsx:976
#: src/components/shortcuts-settings.jsx:1000
msgid "Shortcuts imported"
msgstr "Atalhos importados"

#: src/components/shortcuts-settings.jsx:986
msgid "Import & append…"
msgstr "Importar e anexar…"

#: src/components/shortcuts-settings.jsx:994
msgid "Override current shortcuts?"
msgstr "Substituir atalhos atuais?"

#: src/components/shortcuts-settings.jsx:995
msgid "Import shortcuts?"
msgstr "Importar atalhos?"

#: src/components/shortcuts-settings.jsx:1009
msgid "or override…"
msgstr "ou substituir…"

#: src/components/shortcuts-settings.jsx:1009
msgid "Import…"
msgstr "Importar…"

#: src/components/shortcuts-settings.jsx:1018
msgid "Export"
msgstr "Exportar"

#: src/components/shortcuts-settings.jsx:1033
msgid "Shortcuts copied"
msgstr "Atalhos copiados"

#: src/components/shortcuts-settings.jsx:1036
msgid "Unable to copy shortcuts"
msgstr "Impossível copiar atalhos"

#: src/components/shortcuts-settings.jsx:1050
msgid "Shortcut settings copied"
msgstr "Definições de atalho copiado"

#: src/components/shortcuts-settings.jsx:1053
msgid "Unable to copy shortcut settings"
msgstr "Impossível copiar definições de atalho"

#: src/components/shortcuts-settings.jsx:1083
msgid "Share"
msgstr "Partilhar"

#: src/components/shortcuts-settings.jsx:1122
msgid "Saving shortcuts to instance server…"
msgstr "A guardar atalhos no servidor de instância…"

#: src/components/shortcuts-settings.jsx:1129
msgid "Shortcuts saved"
msgstr "Atalhos guardados"

#: src/components/shortcuts-settings.jsx:1134
msgid "Unable to save shortcuts"
msgstr "Impossível guardar atalhos"

#: src/components/shortcuts-settings.jsx:1137
msgid "Sync to instance server"
msgstr "Sincronizar ao servidor de instância"

#. placeholder {0}: shortcutsStr.length
#: src/components/shortcuts-settings.jsx:1145
msgid "{0, plural, one {# character} other {# characters}}"
msgstr "{0, plural, one {# carácter} other {# carácteres}}"

#: src/components/shortcuts-settings.jsx:1157
msgid "Raw Shortcuts JSON"
msgstr "Atalhos brutos JSON"

#: src/components/shortcuts-settings.jsx:1170
msgid "Import/export settings from/to instance server (Very experimental)"
msgstr "Importar/exportar definições do/para servidor de instância (Muito experimental)"

#: src/components/status.jsx:612
msgid "<0/> <1>boosted</1>"
msgstr "<0/> <1>impulsionou</1>"

#: src/components/status.jsx:711
msgid "Sorry, your current logged-in instance can't interact with this post from another instance."
msgstr "Desculpe, a atual instância registrada não pode interagir com esta publicação de outra instância."

#. placeholder {0}: username || acct
#: src/components/status.jsx:864
msgid "Unliked @{0}'s post"
msgstr "Não gostou da publicação de @{0}"

#. placeholder {0}: username || acct
#: src/components/status.jsx:865
msgid "Liked @{0}'s post"
msgstr "Gostou da publicação de @{0}"

#. placeholder {0}: username || acct
#: src/components/status.jsx:904
msgid "Unbookmarked @{0}'s post"
msgstr "Removeu dos favoritos a publicação de @{0}"

#. placeholder {0}: username || acct
#: src/components/status.jsx:905
msgid "Bookmarked @{0}'s post"
msgstr "Adicionou aos favoritos a publicação de @{0}"

#: src/components/status.jsx:1002
msgid "Some media have no descriptions."
msgstr "Algumas multimédias não possuem descrições."

#. placeholder {0}: rtf.format(-statusMonthsAgo, 'month')
#: src/components/status.jsx:1009
msgid "Old post (<0>{0}</0>)"
msgstr "Publicação antiga (<0>{0}</0>)"

#: src/components/status.jsx:1033
#: src/components/status.jsx:1073
#: src/components/status.jsx:2519
#: src/components/status.jsx:2542
msgid "Unboost"
msgstr "Remover impulso"

#: src/components/status.jsx:1049
#: src/components/status.jsx:2534
msgid "Quote"
msgstr "Citar"

#. placeholder {0}: username || acct
#: src/components/status.jsx:1061
#: src/components/status.jsx:1524
msgid "Unboosted @{0}'s post"
msgstr "Removeu impulso da publicação de @{0}"

#. placeholder {0}: username || acct
#: src/components/status.jsx:1062
#: src/components/status.jsx:1525
msgid "Boosted @{0}'s post"
msgstr "Impulsionou a publicação de @{0}"

#: src/components/status.jsx:1074
msgid "Boost…"
msgstr "Impulsionar…"

#: src/components/status.jsx:1086
#: src/components/status.jsx:1816
#: src/components/status.jsx:2555
msgid "Unlike"
msgstr "Remover gosto"

#: src/components/status.jsx:1087
#: src/components/status.jsx:1816
#: src/components/status.jsx:1817
#: src/components/status.jsx:2555
#: src/components/status.jsx:2556
msgid "Like"
msgstr "Gosto"

#: src/components/status.jsx:1096
#: src/components/status.jsx:2567
msgid "Unbookmark"
msgstr "Eliminar dos favoritos"

#: src/components/status.jsx:1179
msgid "Post text copied"
msgstr "Texto da publicação copiado"

#: src/components/status.jsx:1182
msgid "Unable to copy post text"
msgstr "Impossível copiar texto da publicação"

#: src/components/status.jsx:1188
msgid "Copy post text"
msgstr "Copiar texto da publicação"

#. placeholder {0}: username || acct
#: src/components/status.jsx:1206
msgid "View post by <0>@{0}</0>"
msgstr "Ver publicação de <0>@{0}</0>"

#: src/components/status.jsx:1227
msgid "Show Edit History"
msgstr "Exibir histórico de edições"

#: src/components/status.jsx:1230
msgid "Edited: {editedDateText}"
msgstr "Editado: {editedDateText}"

#: src/components/status.jsx:1297
#: src/components/status.jsx:3328
msgid "Embed post"
msgstr "Incorporar publicação"

#: src/components/status.jsx:1311
msgid "Conversation unmuted"
msgstr "Conversa dessilenciada"

#: src/components/status.jsx:1311
msgid "Conversation muted"
msgstr "Conversa silenciada"

#: src/components/status.jsx:1317
msgid "Unable to unmute conversation"
msgstr "Impossível dessilenciar conversa"

#: src/components/status.jsx:1318
msgid "Unable to mute conversation"
msgstr "Impossível silenciar conversa"

#: src/components/status.jsx:1327
msgid "Unmute conversation"
msgstr "Dessilenciar conversa"

#: src/components/status.jsx:1334
msgid "Mute conversation"
msgstr "Silenciar conversa"

#: src/components/status.jsx:1350
msgid "Post unpinned from profile"
msgstr "Publicação desafixada do perfil"

#: src/components/status.jsx:1351
msgid "Post pinned to profile"
msgstr "Publicação fixada ao perfil"

#: src/components/status.jsx:1356
msgid "Unable to unpin post"
msgstr "Impossível desafixar publicação"

#: src/components/status.jsx:1356
msgid "Unable to pin post"
msgstr "Impossível fixar publicação"

#: src/components/status.jsx:1365
msgid "Unpin from profile"
msgstr "Desafixar do perfil"

#: src/components/status.jsx:1372
msgid "Pin to profile"
msgstr "Fixar ao perfil"

#: src/components/status.jsx:1401
msgid "Delete this post?"
msgstr "Eliminar publicação?"

#: src/components/status.jsx:1417
msgid "Post deleted"
msgstr "Publicação eliminada"

#: src/components/status.jsx:1420
msgid "Unable to delete post"
msgstr "Impossível eliminar publicação"

#: src/components/status.jsx:1448
msgid "Report post…"
msgstr "Relatar publicação…"

#: src/components/status.jsx:1817
#: src/components/status.jsx:1853
#: src/components/status.jsx:2556
msgid "Liked"
msgstr "Gostado"

#: src/components/status.jsx:1850
#: src/components/status.jsx:2543
msgid "Boosted"
msgstr "Impulsionado"

#: src/components/status.jsx:1860
#: src/components/status.jsx:2568
msgid "Bookmarked"
msgstr "Adicionado aos favoritos"

#: src/components/status.jsx:1864
msgid "Pinned"
msgstr "Fixado"

#: src/components/status.jsx:1910
#: src/components/status.jsx:2380
msgid "Deleted"
msgstr "Eliminado"

#: src/components/status.jsx:1951
msgid "{repliesCount, plural, one {# reply} other {# replies}}"
msgstr "{repliesCount, plural, one {# resposta} other {# respostas}}"

#. placeholder {0}: snapStates.statusThreadNumber[sKey] ? ` ${snapStates.statusThreadNumber[sKey]}/X` : ''
#: src/components/status.jsx:2041
msgid "Thread{0}"
msgstr "Tópico{0}"

#: src/components/status.jsx:2119
#: src/components/status.jsx:2181
#: src/components/status.jsx:2276
msgid "Show less"
msgstr "Mostrar menos"

#: src/components/status.jsx:2119
#: src/components/status.jsx:2181
msgid "Show content"
msgstr "Mostrar conteúdo"

#. placeholder {0}: filterInfo.titlesStr
#. placeholder {0}: filterInfo?.titlesStr
#: src/components/status.jsx:2272
#: src/pages/catchup.jsx:1880
msgid "Filtered: {0}"
msgstr "Filtrado: {0}"

#: src/components/status.jsx:2276
msgid "Show media"
msgstr "Mostrar multimédia"

#: src/components/status.jsx:2416
msgid "Edited"
msgstr "Editado"

#: src/components/status.jsx:2493
msgid "Comments"
msgstr "Comentários"

#. More from [Author]
#: src/components/status.jsx:2786
msgid "More from <0/>"
msgstr "Mais de <0/>"

#: src/components/status.jsx:3088
msgid "Edit History"
msgstr "Histórico de edições"

#: src/components/status.jsx:3092
msgid "Failed to load history"
msgstr "Falhou ao carregar histórico"

#: src/components/status.jsx:3097
#: src/pages/annual-report.jsx:45
msgid "Loading…"
msgstr "A carregar…"

#: src/components/status.jsx:3333
msgid "HTML Code"
msgstr "Código HTML"

#: src/components/status.jsx:3350
msgid "HTML code copied"
msgstr "Código HTML copiado"

#: src/components/status.jsx:3353
msgid "Unable to copy HTML code"
msgstr "Impossível copiar código HTML"

#: src/components/status.jsx:3365
msgid "Media attachments:"
msgstr "Anexos de multimédia:"

#: src/components/status.jsx:3387
msgid "Account Emojis:"
msgstr "Emojis da conta:"

#: src/components/status.jsx:3418
#: src/components/status.jsx:3463
msgid "static URL"
msgstr "URL estático"

#: src/components/status.jsx:3432
msgid "Emojis:"
msgstr "Emojis:"

#: src/components/status.jsx:3477
msgid "Notes:"
msgstr "Notas:"

#: src/components/status.jsx:3481
msgid "This is static, unstyled and scriptless. You may need to apply your own styles and edit as needed."
msgstr "Isto é estático, instável e sem guião. Pode precisar para aplicar os seus próprios estilos e editar caso necessário."

#: src/components/status.jsx:3487
msgid "Polls are not interactive, becomes a list with vote counts."
msgstr "Votações não são interativas, ela vira uma lista com contador de votos."

#: src/components/status.jsx:3492
msgid "Media attachments can be images, videos, audios or any file types."
msgstr "Anexos de multimédia pode ser imagens, vídeos, áudios, e qualquer tipo de ficheiro."

#: src/components/status.jsx:3498
msgid "Post could be edited or deleted later."
msgstr "Publicações podem ser editadas ou eliminadas depois."

#: src/components/status.jsx:3504
msgid "Preview"
msgstr "Prévia"

#: src/components/status.jsx:3513
msgid "Note: This preview is lightly styled."
msgstr "Nota: Esta prévia tem um estilo levemente padronizado."

#. [Name] [Visibility icon] boosted
#: src/components/status.jsx:3766
msgid "<0/> <1/> boosted"
msgstr "<0/> <1/> impulsionou"

#: src/components/timeline.jsx:479
#: src/pages/settings.jsx:1179
msgid "New posts"
msgstr "Novas publicações"

#: src/components/timeline.jsx:580
#: src/pages/home.jsx:216
#: src/pages/notifications.jsx:890
#: src/pages/status.jsx:1008
#: src/pages/status.jsx:1381
msgid "Try again"
msgstr "Tentar novamente"

#. placeholder {0}: fItems.length
#: src/components/timeline.jsx:615
msgid "{0, plural, one {# Boost} other {# Boosts}}"
msgstr "{0, plural, one {# Impulso} other {# Impulsos}}"

#: src/components/timeline.jsx:620
msgid "Pinned posts"
msgstr "Publicações fixadas"

#: src/components/timeline.jsx:979
#: src/components/timeline.jsx:986
#: src/pages/catchup.jsx:1898
msgid "Thread"
msgstr "Tópico"

#. placeholder {0}: filterInfo.titlesStr
#: src/components/timeline.jsx:1001
msgid "<0>Filtered</0>: <1>{0}</1>"
msgstr "<0>Filtrado</0>: <1>{0}</1>"

#: src/components/translation-block.jsx:192
msgid "Auto-translated from {sourceLangText}"
msgstr "Traduzido automaticamente de {sourceLangText}"

#: src/components/translation-block.jsx:230
msgid "Translating…"
msgstr "A traduzir…"

#: src/components/translation-block.jsx:233
msgid "Translate from {sourceLangText} (auto-detected)"
msgstr "Traduzir do {sourceLangText} (detetado automaticamente)"

#: src/components/translation-block.jsx:234
msgid "Translate from {sourceLangText}"
msgstr "Traduzir do {sourceLangText}"

#. placeholder {0}: detectedLang ?? '…'
#: src/components/translation-block.jsx:262
msgid "Auto ({0})"
msgstr "Auto ({0})"

#: src/components/translation-block.jsx:275
msgid "Failed to translate"
msgstr "Falhou ao traduzir"

#: src/compose.jsx:33
msgid "Editing source status"
msgstr "A editar mensagem original"

#. placeholder {0}: replyToStatus.account?.acct || replyToStatus.account?.username
#: src/compose.jsx:35
msgid "Replying to @{0}"
msgstr "Respondendo à @{0}"

#: src/compose.jsx:63
msgid "You may close this page now."
msgstr "Deves fechar esta página agora."

#: src/compose.jsx:71
msgid "Close window"
msgstr "Fechar janela"

#: src/compose.jsx:87
msgid "Login required."
msgstr "Requer iniciar sessão."

#: src/compose.jsx:91
#: src/pages/annual-report.jsx:164
#: src/pages/http-route.jsx:91
#: src/pages/login.jsx:271
msgid "Go home"
msgstr "Voltar à página inicial"

#: src/pages/account-statuses.jsx:232
msgid "Account posts"
msgstr "Publicações da conta"

#: src/pages/account-statuses.jsx:239
msgid "{accountDisplay} (+ Replies)"
msgstr "{accountDisplay} (+ Respostas)"

#: src/pages/account-statuses.jsx:241
msgid "{accountDisplay} (- Boosts)"
msgstr "{accountDisplay} (- Impulsos)"

#: src/pages/account-statuses.jsx:243
msgid "{accountDisplay} (#{tagged})"
msgstr "{accountDisplay} (#{tagged})"

#: src/pages/account-statuses.jsx:245
msgid "{accountDisplay} (Media)"
msgstr "{accountDisplay} (Multimédia)"

#: src/pages/account-statuses.jsx:251
msgid "{accountDisplay} ({monthYear})"
msgstr "{accountDisplay} ({monthYear})"

#: src/pages/account-statuses.jsx:316
msgid "Clear filters"
msgstr "Limpar filtro"

#: src/pages/account-statuses.jsx:319
msgid "Clear"
msgstr "Limpar"

#: src/pages/account-statuses.jsx:333
msgid "Showing post with replies"
msgstr "A exibir publicação com respostas"

#: src/pages/account-statuses.jsx:338
msgid "+ Replies"
msgstr "+ Respostas"

#: src/pages/account-statuses.jsx:344
msgid "Showing posts without boosts"
msgstr "A exibir publicações sem impulsos"

#: src/pages/account-statuses.jsx:349
msgid "- Boosts"
msgstr "- Impulsos"

#: src/pages/account-statuses.jsx:355
msgid "Showing posts with media"
msgstr "A exibir publicações com multimédia"

#. placeholder {0}: tag.name
#: src/pages/account-statuses.jsx:372
msgid "Showing posts tagged with #{0}"
msgstr "A exibir publicações marcadas com #{0}"

#. placeholder {0}: date.toLocaleString(i18n.locale, { month: 'long', year: 'numeric', })
#: src/pages/account-statuses.jsx:411
msgid "Showing posts in {0}"
msgstr "A exibir publicações em {0}"

#: src/pages/account-statuses.jsx:500
msgid "Nothing to see here yet."
msgstr "Não há nada para ver aqui."

#: src/pages/account-statuses.jsx:501
#: src/pages/public.jsx:98
#: src/pages/trending.jsx:447
msgid "Unable to load posts"
msgstr "Impossível carregar publicações"

#: src/pages/account-statuses.jsx:542
#: src/pages/account-statuses.jsx:572
msgid "Unable to fetch account info"
msgstr "Impossível obter informações da conta"

#. placeholder {0}: accountInstance ? ( <> {' '} (<b>{punycode.toUnicode(accountInstance)}</b>) </> ) : null
#: src/pages/account-statuses.jsx:549
msgid "Switch to account's instance {0}"
msgstr "Alterar a instância da conta {0}"

#: src/pages/account-statuses.jsx:579
msgid "Switch to my instance (<0>{currentInstance}</0>)"
msgstr "Alterar para a minha instância (<0>{currentInstance}</0>)"

#: src/pages/account-statuses.jsx:641
msgid "Month"
msgstr "Mês"

#: src/pages/accounts.jsx:56
msgid "Current"
msgstr "Atual"

#: src/pages/accounts.jsx:102
msgid "Default"
msgstr "Padrão"

#: src/pages/accounts.jsx:124
msgid "Switch to this account"
msgstr "Alterar para esta conta"

#: src/pages/accounts.jsx:133
msgid "Switch in new tab/window"
msgstr "Alterar para nova janela/aba"

#: src/pages/accounts.jsx:147
msgid "View profile…"
msgstr "Ver perfil…"

#: src/pages/accounts.jsx:164
msgid "Set as default"
msgstr "Definir como padrão"

#. placeholder {0}: account.info.acct
#: src/pages/accounts.jsx:174
msgid "Log out <0>@{0}</0>?"
msgstr "Finalizar sessão <0>@{0}</0>?"

#: src/pages/accounts.jsx:197
msgid "Log out…"
msgstr "Finalizar sessão…"

#: src/pages/accounts.jsx:210
msgid "Add an existing account"
msgstr "Adicionar conta existente"

#: src/pages/accounts.jsx:217
msgid "Note: <0>Default</0> account will always be used for first load. Switched accounts will persist during the session."
msgstr "Nota: as contas <0>padrões</0> sempre serão as primeiras a carregar. Contas alteradas permaneceram durante a sessão."

#: src/pages/bookmarks.jsx:26
msgid "No bookmarks yet. Go bookmark something!"
msgstr "Sem favoritos ainda. Favorita algo primeiramente!"

#: src/pages/bookmarks.jsx:27
msgid "Unable to load bookmarks."
msgstr "Impossível carregar favoritos."

#: src/pages/catchup.jsx:55
msgid "last 1 hour"
msgstr "última 1 hora"

#: src/pages/catchup.jsx:56
msgid "last 2 hours"
msgstr "últimas 2 horas"

#: src/pages/catchup.jsx:57
msgid "last 3 hours"
msgstr "últimas 3 horas"

#: src/pages/catchup.jsx:58
msgid "last 4 hours"
msgstr "últimas 4 horas"

#: src/pages/catchup.jsx:59
msgid "last 5 hours"
msgstr "últimas 5 horas"

#: src/pages/catchup.jsx:60
msgid "last 6 hours"
msgstr "últimas 6 horas"

#: src/pages/catchup.jsx:61
msgid "last 7 hours"
msgstr "últimas 7 horas"

#: src/pages/catchup.jsx:62
msgid "last 8 hours"
msgstr "últimas 8 horas"

#: src/pages/catchup.jsx:63
msgid "last 9 hours"
msgstr "últimas 9 horas"

#: src/pages/catchup.jsx:64
msgid "last 10 hours"
msgstr "últimas 10 horas"

#: src/pages/catchup.jsx:65
msgid "last 11 hours"
msgstr "últimas 11 horas"

#: src/pages/catchup.jsx:66
msgid "last 12 hours"
msgstr "últimas 12 horas"

#: src/pages/catchup.jsx:67
msgid "beyond 12 hours"
msgstr "além de 12 horas"

#: src/pages/catchup.jsx:74
msgid "Followed tags"
msgstr "Marcações seguidas"

#: src/pages/catchup.jsx:75
msgid "Groups"
msgstr "Grupos"

#: src/pages/catchup.jsx:597
msgid "Showing {selectedFilterCategory, select, all {all posts} original {original posts} replies {replies} boosts {boosts} followedTags {followed tags} groups {groups} filtered {filtered posts}}, {sortBy, select, createdAt {{sortOrder, select, asc {oldest} desc {latest}}} reblogsCount {{sortOrder, select, asc {fewest boosts} desc {most boosts}}} favouritesCount {{sortOrder, select, asc {fewest likes} desc {most likes}}} repliesCount {{sortOrder, select, asc {fewest replies} desc {most replies}}} density {{sortOrder, select, asc {least dense} desc {most dense}}}} first{groupBy, select, account {, grouped by authors} other {}}"
msgstr "A exibir {selectedFilterCategory, select, all {todas as publicações} original {publicações originais} replies {respostas} boosts {impulsos} followedTags {marcações seguidas} groups {grupos} filtered {publicações filtradas}}, {sortBy, select, createdAt {{sortOrder, select, asc {mais antigo} desc {mais recente}}} reblogsCount {{sortOrder, select, asc {menos impulsos} desc {mais impulsos}}} favouritesCount {{sortOrder, select, asc {menos gostos} desc {mais gostos}}} repliesCount {{sortOrder, select, asc {menos respostas} desc {mais respostas}}} density {{sortOrder, select, asc {menos denso} desc {mais denso}}}} primeiro{groupBy, select, account {, agrupado por autores} other {}}"

#: src/pages/catchup.jsx:888
#: src/pages/catchup.jsx:912
msgid "Catch-up <0>beta</0>"
msgstr "Acompanhar <0>beta</0>"

#: src/pages/catchup.jsx:902
#: src/pages/catchup.jsx:1587
msgid "Help"
msgstr "Ajuda"

#: src/pages/catchup.jsx:918
msgid "What is this?"
msgstr "O que isto significa?"

#: src/pages/catchup.jsx:921
msgid "Catch-up is a separate timeline for your followings, offering a high-level view at a glance, with a simple, email-inspired interface to effortlessly sort and filter through posts."
msgstr "Acompanhar é uma linha de tempo separada dos seus seguidores, oferecendo uma vista de alto-nível num relance, com uma simples interface inspirada em e-mails, para ordenar e filtrar sem esforço através das publicações."

#: src/pages/catchup.jsx:932
msgid "Preview of Catch-up UI"
msgstr "Prévia da interface de acompanhamento"

#: src/pages/catchup.jsx:941
msgid "Let's catch up"
msgstr "Vamos acompanhar"

#: src/pages/catchup.jsx:946
msgid "Let's catch up on the posts from your followings."
msgstr "Vamos acompanhar as publicações dos seus seguidores."

#: src/pages/catchup.jsx:950
msgid "Show me all posts from…"
msgstr "Exiba-me as publicações de…"

#: src/pages/catchup.jsx:973
msgid "until the max"
msgstr "até o máximo"

#: src/pages/catchup.jsx:1003
msgid "Catch up"
msgstr "Acompanhar"

#: src/pages/catchup.jsx:1009
msgid "Overlaps with your last catch-up"
msgstr "Sobreposições com o seu último acompanhamento"

#. placeholder {0}: dtf.format(new Date(lastCatchupEndAt))
#: src/pages/catchup.jsx:1021
msgid "Until the last catch-up ({0})"
msgstr "Até o último acompanhamento ({0})"

#: src/pages/catchup.jsx:1030
msgid "Note: your instance might only show a maximum of 800 posts in the Home timeline regardless of the time range. Could be less or more."
msgstr "Nota: a sua instância talvez mostre um máximo de 800 publicações na linha de tempo da página inicial, independente do intervalo de tempo. Pode ser menos ou mais."

#: src/pages/catchup.jsx:1040
msgid "Previously…"
msgstr "Antes…"

#. placeholder {0}: pc.count
#: src/pages/catchup.jsx:1058
msgid "{0, plural, one {# post} other {# posts}}"
msgstr "{0, plural, one {# publicação} other {# publicações}}"

#: src/pages/catchup.jsx:1068
msgid "Remove this catch-up?"
msgstr "Eliminar acompanhamento?"

#. placeholder {0}: pc.id
#: src/pages/catchup.jsx:1071
msgid "Removing Catch-up {0}"
msgstr "A remover acompanhamento {0}"

#. placeholder {0}: pc.id
#: src/pages/catchup.jsx:1075
msgid "Catch-up {0} removed"
msgstr "Acompanhamento {0} removido"

#: src/pages/catchup.jsx:1089
msgid "Note: Only max 3 will be stored. The rest will be automatically removed."
msgstr "Nota: Aqui guardará um máximo de 3 acompanhamentos. O resto será automaticamente eliminado."

#: src/pages/catchup.jsx:1104
msgid "Fetching posts…"
msgstr "A obter publicações…"

#: src/pages/catchup.jsx:1107
msgid "This might take a while."
msgstr "Isto deve levar um tempo."

#: src/pages/catchup.jsx:1142
msgid "Reset filters"
msgstr "Redefinir filtros"

#: src/pages/catchup.jsx:1150
#: src/pages/catchup.jsx:1593
msgid "Top links"
msgstr "Ligações populares"

#. placeholder {0}: sharers.map((s) => { const { avatarStatic, displayName } = s; return ( <button type="button" class="plain" style={{ padding: 0, }} onClick={(e) => { e.preventDefault(); e.stopPropagation(); // Reset and filter to author const { id } = s; setSelectedAuthor(id); setSelectedFilterCategory('all'); }} > <Avatar url={avatarStatic} size="s" alt={displayName} /> </button> ); })
#: src/pages/catchup.jsx:1263
msgid "Shared by {0}"
msgstr "Partilhado por {0}"

#: src/pages/catchup.jsx:1318
#: src/pages/mentions.jsx:148
#: src/pages/search.jsx:326
msgid "All"
msgstr "Tudo"

#. placeholder {0}: authorCountsList.length
#: src/pages/catchup.jsx:1403
msgid "{0, plural, one {# author} other {# authors}}"
msgstr "{0, plural, one {# autor} other {# autores}}"

#: src/pages/catchup.jsx:1415
msgid "Sort"
msgstr "Ordenar"

#: src/pages/catchup.jsx:1446
msgid "Date"
msgstr "Data"

#: src/pages/catchup.jsx:1450
msgid "Density"
msgstr "Densidade"

#. js-lingui-explicit-id
#: src/pages/catchup.jsx:1473
msgid "group.filter"
msgstr "Filtrar"

#: src/pages/catchup.jsx:1488
msgid "Authors"
msgstr "Autores"

#: src/pages/catchup.jsx:1489
msgid "None"
msgstr "Nenhum"

#: src/pages/catchup.jsx:1505
msgid "Show all authors"
msgstr "Exibir autores"

#: src/pages/catchup.jsx:1556
msgid "You don't have to read everything."
msgstr "Não precisa ler tudo."

#: src/pages/catchup.jsx:1557
msgid "That's all."
msgstr "Isto é tudo."

#: src/pages/catchup.jsx:1565
msgid "Back to top"
msgstr "Voltar ao topo"

#: src/pages/catchup.jsx:1596
msgid "Links shared by followings, sorted by shared counts, boosts and likes."
msgstr "Ligações partilhadas por seus seguidores, ordenadas por contagem de vezes partilhadas, impulsos e gostos."

#: src/pages/catchup.jsx:1602
msgid "Sort: Density"
msgstr "Ordenar: Densidade"

#: src/pages/catchup.jsx:1605
msgid "Posts are sorted by information density or depth. Shorter posts are \"lighter\" while longer posts are \"heavier\". Posts with photos are \"heavier\" than posts without photos."
msgstr "Publicações são ordenadas por informações de densidade ou profundidade. Publicações curtas são mais \"leves\" enquanto as longas são mais \"pesadas\". Elas com fotos são mais \"pesadas\" do que elas sem fotos."

#: src/pages/catchup.jsx:1612
msgid "Group: Authors"
msgstr "Grupo: Autores"

#: src/pages/catchup.jsx:1615
msgid "Posts are grouped by authors, sorted by posts count per author."
msgstr "Publicações são agrupadas por autores, ordenado por quantidade de publicações por autor."

#: src/pages/catchup.jsx:1662
msgid "Next author"
msgstr "Próximo autor"

#: src/pages/catchup.jsx:1670
msgid "Previous author"
msgstr "Autor anterior"

#: src/pages/catchup.jsx:1686
msgid "Scroll to top"
msgstr "Rolar até o topo"

#: src/pages/favourites.jsx:26
msgid "No likes yet. Go like something!"
msgstr "Sem gostos ainda. Dá um ❤️ em algo!"

#: src/pages/favourites.jsx:27
msgid "Unable to load likes."
msgstr "Impossível carregar gostos."

#: src/pages/filters.jsx:23
msgid "Home and lists"
msgstr "Página inicial e listas"

#: src/pages/filters.jsx:25
msgid "Public timelines"
msgstr "Linhas de tempo públicas"

#: src/pages/filters.jsx:26
msgid "Conversations"
msgstr "Conversas"

#: src/pages/filters.jsx:27
msgid "Profiles"
msgstr "Perfis"

#: src/pages/filters.jsx:42
msgid "Never"
msgstr "Nunca"

#: src/pages/filters.jsx:104
#: src/pages/filters.jsx:229
msgid "New filter"
msgstr "Novo filtro"

#. placeholder {0}: filters.length
#: src/pages/filters.jsx:152
msgid "{0, plural, one {# filter} other {# filters}}"
msgstr "{0, plural, one {# filtro} other {# filtros}}"

#: src/pages/filters.jsx:167
msgid "Unable to load filters."
msgstr "Impossível carregar filtros."

#: src/pages/filters.jsx:171
msgid "No filters yet."
msgstr "Sem filtro ainda."

#: src/pages/filters.jsx:178
msgid "Add filter"
msgstr "Adicionar filtro"

#: src/pages/filters.jsx:229
msgid "Edit filter"
msgstr "Editar filtro"

#: src/pages/filters.jsx:346
msgid "Unable to edit filter"
msgstr "Impossível editar filtro"

#: src/pages/filters.jsx:347
msgid "Unable to create filter"
msgstr "Impossível criar filtro"

#: src/pages/filters.jsx:356
msgid "Title"
msgstr "Título"

#: src/pages/filters.jsx:397
msgid "Whole word"
msgstr "Palavra completa"

#: src/pages/filters.jsx:423
msgid "No keywords. Add one."
msgstr "Sem palavras-chave. Adicione uma."

#: src/pages/filters.jsx:450
msgid "Add keyword"
msgstr "Adicionar palavra-chave"

#. placeholder {0}: filteredEditKeywords.length
#: src/pages/filters.jsx:454
msgid "{0, plural, one {# keyword} other {# keywords}}"
msgstr "{0, plural, one {# palavra-chave} other {# palavras-chave}}"

#: src/pages/filters.jsx:467
msgid "Filter from…"
msgstr "Filtrar de…"

#: src/pages/filters.jsx:493
msgid "* Not implemented yet"
msgstr "* Não implementado ainda"

#: src/pages/filters.jsx:499
msgid "Status: <0><1/></0>"
msgstr "Estado: <0><1/></0>"

#: src/pages/filters.jsx:508
msgid "Change expiry"
msgstr "Alterar expiração"

#: src/pages/filters.jsx:508
msgid "Expiry"
msgstr "Expiração"

#: src/pages/filters.jsx:527
msgid "Filtered post will be…"
msgstr "A publicação filtrada será…"

#: src/pages/filters.jsx:538
msgid "obscured (media only)"
msgstr "oculto (só multimédia)"

#: src/pages/filters.jsx:552
msgid "minimized"
msgstr "minimizada"

#: src/pages/filters.jsx:562
msgid "hidden"
msgstr "oculta"

#: src/pages/filters.jsx:579
msgid "Delete this filter?"
msgstr "Eliminar filtro?"

#: src/pages/filters.jsx:592
msgid "Unable to delete filter."
msgstr "Impossível eliminar filtro."

#: src/pages/filters.jsx:625
msgid "Expired"
msgstr "Expirado"

#: src/pages/filters.jsx:627
msgid "Expiring <0/>"
msgstr "A expirar <0/>"

#: src/pages/filters.jsx:631
msgid "Never expires"
msgstr "Nunca expira"

#. placeholder {0}: followedHashtags.length
#: src/pages/followed-hashtags.jsx:71
msgid "{0, plural, one {# hashtag} other {# hashtags}}"
msgstr "{0, plural, one {# hashtag} other {# hashtags}}"

#: src/pages/followed-hashtags.jsx:86
msgid "Unable to load followed hashtags."
msgstr "Impossível carregar hashtags seguidas."

#: src/pages/followed-hashtags.jsx:90
msgid "No hashtags followed yet."
msgstr "Nenhuma hashtag seguida ainda."

#: src/pages/following.jsx:144
msgid "Nothing to see here."
msgstr "Nada para ver aqui."

#: src/pages/following.jsx:145
#: src/pages/list.jsx:109
msgid "Unable to load posts."
msgstr "Impossível carregar publicações."

#: src/pages/hashtag.jsx:56
msgid "{hashtagTitle} (Media only) on {instance}"
msgstr "{hashtagTitle} (Somente multimédia) em {instance}"

#: src/pages/hashtag.jsx:57
msgid "{hashtagTitle} on {instance}"
msgstr "{hashtagTitle} em {instance}"

#: src/pages/hashtag.jsx:59
msgid "{hashtagTitle} (Media only)"
msgstr "{hashtagTitle} (Somente multimédia)"

#: src/pages/hashtag.jsx:60
msgid "{hashtagTitle}"
msgstr "{hashtagTitle}"

#: src/pages/hashtag.jsx:182
msgid "No one has posted anything with this tag yet."
msgstr "Ninguém publicou nada com esta marcação ainda."

#: src/pages/hashtag.jsx:183
msgid "Unable to load posts with this tag"
msgstr "Impossível carregar publicações com esta marcação"

#: src/pages/hashtag.jsx:209
msgid "Unfollow #{hashtag}?"
msgstr "Deixar de seguir #{hashtag}?"

#: src/pages/hashtag.jsx:224
msgid "Unfollowed #{hashtag}"
msgstr "Deixou de seguir #{hashtag}"

#: src/pages/hashtag.jsx:239
msgid "Followed #{hashtag}"
msgstr "#{hashtag} seguido"

#: src/pages/hashtag.jsx:255
msgid "Following…"
msgstr "A seguir…"

#: src/pages/hashtag.jsx:283
msgid "Unfeatured on profile"
msgstr "Não destacado no perfil"

#: src/pages/hashtag.jsx:297
msgid "Unable to unfeature on profile"
msgstr "Impossível remover destaque do perfil"

#: src/pages/hashtag.jsx:306
#: src/pages/hashtag.jsx:322
msgid "Featured on profile"
msgstr "Destacado no perfil"

#: src/pages/hashtag.jsx:329
msgid "Feature on profile"
msgstr "Destacar no perfil"

#: src/pages/hashtag.jsx:394
msgid "{TOTAL_TAGS_LIMIT, plural, other {Max # tags}}"
msgstr "{TOTAL_TAGS_LIMIT, plural, other {Máx. # marcações}}"

#: src/pages/hashtag.jsx:397
msgid "Add hashtag"
msgstr "Adicionar hashtag"

#: src/pages/hashtag.jsx:429
msgid "Remove hashtag"
msgstr "Eliminar hashtag"

#: src/pages/hashtag.jsx:443
msgid "{SHORTCUTS_LIMIT, plural, one {Max # shortcut reached. Unable to add shortcut.} other {Max # shortcuts reached. Unable to add shortcut.}}"
msgstr "{SHORTCUTS_LIMIT, plural, one {Máx. # atalho alcançado. Impossível adicionar atalho.} other {Máx. # atalhos alcançados. Impossível adicionar atalho.}}"

#: src/pages/hashtag.jsx:472
msgid "This shortcut already exists"
msgstr "Este atalho já existe"

#: src/pages/hashtag.jsx:475
msgid "Hashtag shortcut added"
msgstr "Atalho da hashtag adicionada"

#: src/pages/hashtag.jsx:481
msgid "Add to Shortcuts"
msgstr "Adicionar aos atalhos"

#: src/pages/hashtag.jsx:487
#: src/pages/public.jsx:140
#: src/pages/trending.jsx:476
msgid "Enter a new instance e.g. \"mastodon.social\""
msgstr "Digite uma nova instância ex. \"mastodon.social\""

#: src/pages/hashtag.jsx:490
#: src/pages/public.jsx:143
#: src/pages/trending.jsx:479
msgid "Invalid instance"
msgstr "Instância inválida"

#: src/pages/hashtag.jsx:504
#: src/pages/public.jsx:157
#: src/pages/trending.jsx:491
msgid "Go to another instance…"
msgstr "Ir à outra instância…"

#: src/pages/hashtag.jsx:517
#: src/pages/public.jsx:170
#: src/pages/trending.jsx:502
msgid "Go to my instance (<0>{currentInstance}</0>)"
msgstr "Ir à minha instância (<0>{currentInstance}</0>)"

#: src/pages/home.jsx:212
msgid "Unable to fetch notifications."
msgstr "Impossível obter notificações."

#: src/pages/home.jsx:233
msgid "<0>New</0> <1>Follow Requests</1>"
msgstr "<0>Novos</0> <1>Pedidos de seguir</1>"

#: src/pages/home.jsx:239
msgid "See all"
msgstr "Ver tudo"

#: src/pages/http-route.jsx:68
msgid "Resolving…"
msgstr "A resolver…"

#: src/pages/http-route.jsx:79
msgid "Unable to resolve URL"
msgstr "Impossível resolver URL"

#: src/pages/list.jsx:108
msgid "Nothing yet."
msgstr "Nada ainda."

#: src/pages/list.jsx:177
#: src/pages/list.jsx:281
msgid "Manage members"
msgstr "Gerir membros"

#. placeholder {0}: account.username
#: src/pages/list.jsx:316
msgid "Remove <0>@{0}</0> from list?"
msgstr "Eliminar <0>@{0}</0> da lista?"

#: src/pages/list.jsx:362
msgid "Remove…"
msgstr "Eliminar…"

#. placeholder {0}: lists.length
#: src/pages/lists.jsx:94
msgid "{0, plural, one {# list} other {# lists}}"
msgstr "{0, plural, one {# lista} other {# listas}}"

#: src/pages/lists.jsx:109
msgid "No lists yet."
msgstr "Nenhuma lista ainda."

#: src/pages/login.jsx:110
#: src/pages/login.jsx:123
msgid "Failed to register application"
msgstr "Falhou ao registar aplicação"

#: src/pages/login.jsx:209
msgid "instance domain"
msgstr "domínio de instância"

#: src/pages/login.jsx:233
msgid "e.g. “mastodon.social”"
msgstr "ex. “mastodon.social”"

#: src/pages/login.jsx:244
msgid "Failed to log in. Please try again or try another instance."
msgstr "Falhou ao iniciar sessão. Tente novamente ou tente outra instância."

#: src/pages/login.jsx:256
msgid "Continue with {selectedInstanceText}"
msgstr "Continuar com {selectedInstanceText}"

#: src/pages/login.jsx:257
msgid "Continue"
msgstr "Continuar"

#: src/pages/login.jsx:265
msgid "Don't have an account? Create one!"
msgstr "Não tem uma conta? Cria uma!"

#: src/pages/mentions.jsx:21
msgid "Private mentions"
msgstr "Menções privadas"

#: src/pages/mentions.jsx:160
msgid "Private"
msgstr "Privado"

#: src/pages/mentions.jsx:170
msgid "No one mentioned you :("
msgstr "Ninguém lhe mencionou... ☹️"

#: src/pages/mentions.jsx:171
msgid "Unable to load mentions."
msgstr "Impossível carregar menções."

#: src/pages/notifications.jsx:105
msgid "You don't follow"
msgstr "Não segues"

#: src/pages/notifications.jsx:106
msgid "Who don't follow you"
msgstr "Quem não lhe segue"

#: src/pages/notifications.jsx:107
msgid "With a new account"
msgstr "Com uma conta nova"

#: src/pages/notifications.jsx:108
msgid "Who unsolicitedly private mention you"
msgstr "Quem lhe mencionou privadamente sem pedir"

#: src/pages/notifications.jsx:109
msgid "Who are limited by server moderators"
msgstr "Quem está limitado por moderadores do servidor"

#: src/pages/notifications.jsx:597
#: src/pages/notifications.jsx:938
msgid "Notifications settings"
msgstr "Definições de notificação"

#: src/pages/notifications.jsx:615
msgid "New notifications"
msgstr "Novas notificações"

#. placeholder {0}: announcements.length
#: src/pages/notifications.jsx:626
msgid "{0, plural, one {Announcement} other {Announcements}}"
msgstr "{0, plural, one {Anunciado} other {Anunciados}}"

#: src/pages/notifications.jsx:673
#: src/pages/settings.jsx:1167
msgid "Follow requests"
msgstr "Pedidos de seguir"

#. placeholder {0}: followRequests.length
#: src/pages/notifications.jsx:678
msgid "{0, plural, one {# follow request} other {# follow requests}}"
msgstr "{0, plural, one {# pedido de seguir} other {# pedidos de seguir}}"

#. placeholder {0}: notificationsPolicy.summary.pendingRequestsCount
#: src/pages/notifications.jsx:733
msgid "{0, plural, one {Filtered notifications from # person} other {Filtered notifications from # people}}"
msgstr "{0, plural, one {Notificações filtradas de # pessoa} other {Notificações filtradas de # pessoas}}"

#: src/pages/notifications.jsx:806
msgid "Only mentions"
msgstr "Somente menções"

#: src/pages/notifications.jsx:810
msgid "Today"
msgstr "Hoje"

#: src/pages/notifications.jsx:815
msgid "You're all caught up."
msgstr "Está tudo em dia."

#: src/pages/notifications.jsx:838
msgid "Yesterday"
msgstr "Ontem"

#: src/pages/notifications.jsx:886
msgid "Unable to load notifications"
msgstr "Impossível carregar notificações"

#: src/pages/notifications.jsx:965
msgid "Notifications settings updated"
msgstr "Definições de notificação atualizada"

#: src/pages/notifications.jsx:973
msgid "Filter out notifications from people:"
msgstr "Filtrar notificações de pessoas:"

#: src/pages/notifications.jsx:987
msgid "Filter"
msgstr "Filtrar"

#: src/pages/notifications.jsx:990
msgid "Ignore"
msgstr "Ignorar"

#. placeholder {0}: niceDateTime(updatedAtDate)
#: src/pages/notifications.jsx:1063
msgid "Updated <0>{0}</0>"
msgstr "Atualizado <0>{0}</0>"

#. placeholder {0}: account.username
#: src/pages/notifications.jsx:1131
msgid "View notifications from <0>@{0}</0>"
msgstr "Ver notificações de <0>@{0}</0>"

#. placeholder {0}: account.username
#: src/pages/notifications.jsx:1152
msgid "Notifications from <0>@{0}</0>"
msgstr "Notificações de <0>@{0}</0>"

#. placeholder {0}: request.account.username
#: src/pages/notifications.jsx:1220
msgid "Notifications from @{0} will not be filtered from now on."
msgstr "Notificações de @{0} não serão mais filtradas."

#: src/pages/notifications.jsx:1225
msgid "Unable to accept notification request"
msgstr "Impossível aceitar pedido de notificação"

#: src/pages/notifications.jsx:1230
msgid "Allow"
msgstr "Permitir"

#. placeholder {0}: request.account.username
#: src/pages/notifications.jsx:1250
msgid "Notifications from @{0} will not show up in Filtered notifications from now on."
msgstr "Notificações de @{0} não irão mais aparecer em notificações filtradas."

#: src/pages/notifications.jsx:1255
msgid "Unable to dismiss notification request"
msgstr "Impossível descartar pedido de notificação"

#: src/pages/notifications.jsx:1260
msgid "Dismiss"
msgstr "Descartar"

#: src/pages/notifications.jsx:1275
msgid "Dismissed"
msgstr "Descartado"

#: src/pages/public.jsx:28
msgid "Local timeline ({instance})"
msgstr "Linha de tempo local ({instance})"

#: src/pages/public.jsx:29
msgid "Federated timeline ({instance})"
msgstr "Linha de tempo federado ({instance})"

#: src/pages/public.jsx:91
msgid "Local timeline"
msgstr "Linha de tempo local"

#: src/pages/public.jsx:91
msgid "Federated timeline"
msgstr "Linha de tempo federado"

#: src/pages/public.jsx:97
msgid "No one has posted anything yet."
msgstr "Ninguém publicou nada ainda."

#: src/pages/public.jsx:124
msgid "Switch to Federated"
msgstr "Alterar para federado"

#: src/pages/public.jsx:131
msgid "Switch to Local"
msgstr "Alterar para local"

#: src/pages/scheduled-posts.jsx:108
msgid "No scheduled posts."
msgstr "Nenhuma programação."

#. Scheduled [in 1 day] ([Thu, Feb 27, 6:30:00 PM])
#. placeholder {0}: niceDateTime(scheduledAt, { formatOpts: { weekday: 'short', second: 'numeric', }, })
#: src/pages/scheduled-posts.jsx:205
msgid "Scheduled <0><1/></0> <2>({0})</2>"
msgstr "Programou <0><1/></0> <2>({0})</2>"

#. Scheduled [in 1 day]
#: src/pages/scheduled-posts.jsx:261
msgid "Scheduled <0><1/></0>"
msgstr "Programado <0><1/></0>"

#: src/pages/scheduled-posts.jsx:306
msgid "Scheduled post rescheduled"
msgstr "Publicação programada reprogramada"

#: src/pages/scheduled-posts.jsx:313
msgid "Failed to reschedule post"
msgstr "Falhou ao reprogramar publicação"

#: src/pages/scheduled-posts.jsx:336
msgid "Reschedule"
msgstr "Reprogramar"

#: src/pages/scheduled-posts.jsx:342
msgid "Delete scheduled post?"
msgstr "Eliminar publicação programada?"

#: src/pages/scheduled-posts.jsx:350
msgid "Scheduled post deleted"
msgstr "Publicação programada eliminada"

#: src/pages/scheduled-posts.jsx:357
msgid "Failed to delete scheduled post"
msgstr "Falhou ao eliminar publicação programada"

#: src/pages/search.jsx:50
msgid "Search: {q} (Posts)"
msgstr "Buscar: {q} (Publicações)"

#: src/pages/search.jsx:53
msgid "Search: {q} (Accounts)"
msgstr "Buscar: {q} (Contas)"

#: src/pages/search.jsx:56
msgid "Search: {q} (Hashtags)"
msgstr "Buscar: {q} (Hashtags)"

#: src/pages/search.jsx:59
msgid "Search: {q}"
msgstr "Buscar: {q}"

#: src/pages/search.jsx:336
#: src/pages/search.jsx:418
msgid "Hashtags"
msgstr "Hashtags"

#: src/pages/search.jsx:368
#: src/pages/search.jsx:422
#: src/pages/search.jsx:492
msgid "See more"
msgstr "Ver mais"

#: src/pages/search.jsx:394
msgid "See more accounts"
msgstr "Ver mais contas"

#: src/pages/search.jsx:408
msgid "No accounts found."
msgstr "Nenhuma conta encontrada."

#: src/pages/search.jsx:464
msgid "See more hashtags"
msgstr "Ver mais hashtags"

#: src/pages/search.jsx:478
msgid "No hashtags found."
msgstr "Nenhuma hashtag encontrada."

#: src/pages/search.jsx:522
msgid "See more posts"
msgstr "Ver mais publicações"

#: src/pages/search.jsx:536
msgid "No posts found."
msgstr "Nenhuma publicação encontrada."

#: src/pages/search.jsx:580
msgid "Enter your search term or paste a URL above to get started."
msgstr "Insira o termo da sua busca ou cole um URL acima para iniciar."

#: src/pages/settings.jsx:92
msgid "Settings"
msgstr "Definições"

#: src/pages/settings.jsx:101
msgid "Appearance"
msgstr "Aparência"

#: src/pages/settings.jsx:177
msgid "Light"
msgstr "Claro"

#: src/pages/settings.jsx:188
msgid "Dark"
msgstr "Escuro"

#: src/pages/settings.jsx:201
msgid "Auto"
msgstr "Automático"

#: src/pages/settings.jsx:211
msgid "Text size"
msgstr "Tamanho do texto"

#. Preview of one character, in smallest size
#. Preview of one character, in largest size
#: src/pages/settings.jsx:216
#: src/pages/settings.jsx:241
msgid "A"
msgstr "A"

#: src/pages/settings.jsx:255
msgid "Display language"
msgstr "Idioma de exibição"

#: src/pages/settings.jsx:264
msgid "Volunteer translations"
msgstr "Traduções de voluntários"

#: src/pages/settings.jsx:275
msgid "Posting"
msgstr "Publicando"

#: src/pages/settings.jsx:282
msgid "Default visibility"
msgstr "Visibilidade padrão"

#: src/pages/settings.jsx:283
#: src/pages/settings.jsx:329
msgid "Synced"
msgstr "Sincronizado"

#: src/pages/settings.jsx:308
msgid "Failed to update posting privacy"
msgstr "Falhou ao atualizar a privacidade da publicação"

#: src/pages/settings.jsx:331
msgid "Synced to your instance server's settings. <0>Go to your instance ({instance}) for more settings.</0>"
msgstr "Sincronizado com as definições de instância do servidor. <0>Vá para a sua instância ({instance}) para mais definições.</0>"

#: src/pages/settings.jsx:346
msgid "Experiments"
msgstr "Experimentos"

#: src/pages/settings.jsx:359
msgid "Auto refresh timeline posts"
msgstr "Atualizar automaticamente publicações da linha do tempo"

#: src/pages/settings.jsx:371
msgid "Boosts carousel"
msgstr "Carrossel de impulsos"

#: src/pages/settings.jsx:388
msgid "Post translation"
msgstr "Tradução da publicação"

#: src/pages/settings.jsx:399
msgid "Translate to "
msgstr "Traduzir para "

#: src/pages/settings.jsx:410
msgid "System language ({systemTargetLanguageText})"
msgstr "Idioma do sistema ({systemTargetLanguageText})"

#. placeholder {0}: snapStates.settings.contentTranslationHideLanguages .length
#: src/pages/settings.jsx:436
msgid "{0, plural, =0 {Hide \"Translate\" button for:} other {Hide \"Translate\" button for (#):}}"
msgstr "{0, plural, =0 {Ocultar o botão de \"Traduzir\" em:} other {Ocultar o botão de \"Traduzir\" por (#):}}"

#: src/pages/settings.jsx:491
msgid "Note: This feature uses external translation services, powered by <0>{TRANSLATION_API_NAME}</0>."
msgstr "Nota: esta funcionalidade usa serviços de tradução externa, feito por <0>{TRANSLATION_API_NAME}</0>."

#: src/pages/settings.jsx:519
msgid "Auto inline translation"
msgstr "Tradução automática"

#: src/pages/settings.jsx:523
msgid "Automatically show translation for posts in timeline. Only works for <0>short</0> posts without content warning, media and poll."
msgstr "Automaticamente exibe tradução para publicações na linha de tempo. Só funciona para publicações <0>curtas</0> sem aviso de conteúdo, multimédia ou enquete."

#: src/pages/settings.jsx:544
msgid "GIF Picker for composer"
msgstr "Selecionador de GIF para escrita"

#: src/pages/settings.jsx:548
msgid "Note: This feature uses external GIF search service, powered by <0>GIPHY</0>. G-rated (suitable for viewing by all ages), tracking parameters are stripped, referrer information is omitted from requests, but search queries and IP address information will still reach their servers."
msgstr "Nota: Este recurso usa serviços externos de busca de GIF, desenvolvido por <0>GIPHY</0>. Avaliado bem (adequado para visualização de todas as idades), parâmetros de rastreamento são listrados, informação de referência é omitida de pedidos, porém as consultas de busca e informação de endereço IP ainda poderá alcançar os servidores do GIPHY."

#: src/pages/settings.jsx:577
msgid "Image description generator"
msgstr "Gerador de descrição de imagem"

#: src/pages/settings.jsx:582
msgid "Only for new images while composing new posts."
msgstr "Apenas para novas imagens enquanto escreve novas publicações."

#: src/pages/settings.jsx:589
msgid "Note: This feature uses external AI service, powered by <0>img-alt-api</0>. May not work well. Only for images and in English."
msgstr "Nota: Este recurso usa serviços externos IA, desenvolvido por <0>img-alt-api</0>. Pode não funcionar bem. Apenas para imagens e em inglês."

#: src/pages/settings.jsx:617
msgid "Server-side grouped notifications"
msgstr "Notificações agrupadas do servidor"

#: src/pages/settings.jsx:621
msgid "Alpha-stage feature. Potentially improved grouping window but basic grouping logic."
msgstr "Recurso em estágio alpha. Janela potencialmente agrupada e melhorada, porém lógica básica de agrupamento."

#: src/pages/settings.jsx:642
msgid "\"Cloud\" import/export for shortcuts settings"
msgstr "Definições de importação/exportação \"Nuvem\" para atalhos"

#: src/pages/settings.jsx:647
msgid "⚠️⚠️⚠️ Very experimental.<0/>Stored in your own profile’s notes. Profile (private) notes are mainly used for other profiles, and hidden for own profile."
msgstr "⚠️⚠️⚠️ Muito experimental.<0/>Guardado nas notas do seu próprio perfil. Notas (privadas) do perfil são mais usadas para outros perfis, e oculto para o próprio perfil."

#: src/pages/settings.jsx:658
msgid "Note: This feature uses currently-logged-in instance server API."
msgstr "Nota: Este recurso usa a API do servidor de instância atualmente registrado."

#: src/pages/settings.jsx:675
msgid "Cloak mode <0>(<1>Text</1> → <2>████</2>)</0>"
msgstr "Modo oculto <0>(<1>Texto</1> → <2>████</2>)</0>"

#: src/pages/settings.jsx:684
msgid "Replace text as blocks, useful when taking screenshots, for privacy reasons."
msgstr "Substitui os textos por blocos, útil quando tirar capturas de ecrã, por razões de privacidade."

#: src/pages/settings.jsx:709
msgid "About"
msgstr "Sobre"

#: src/pages/settings.jsx:748
msgid "<0>Built</0> by <1>@cheeaun</1>"
msgstr "<0>Feito</0> por <1>@cheeaun</1>"

#: src/pages/settings.jsx:777
msgid "Sponsor"
msgstr "Patrocinar"

#: src/pages/settings.jsx:785
msgid "Donate"
msgstr "Doar"

#: src/pages/settings.jsx:797
msgid "Privacy Policy"
msgstr "Política de privacidade"

#. placeholder {0}: WEBSITE.replace(/https?:\/\//g, '').replace(/\/$/, '')
#: src/pages/settings.jsx:804
msgid "<0>Site:</0> {0}"
msgstr "<0>Sítio web:</0> {0}"

#. placeholder {0}: !__FAKE_COMMIT_HASH__ && ( <span class="ib insignificant"> ( <a href={`https://github.com/cheeaun/phanpy/commit/${__COMMIT_HASH__}`} target="_blank" rel="noopener" > <RelativeTime datetime={new Date(__BUILD_TIME__)} /> </a> ) </span> )
#: src/pages/settings.jsx:811
msgid "<0>Version:</0> <1/> {0}"
msgstr "<0>Versão:</0> <1/> {0}"

#: src/pages/settings.jsx:826
msgid "Version string copied"
msgstr "Versão copiada"

#: src/pages/settings.jsx:829
msgid "Unable to copy version string"
msgstr "Impossível copiar versão"

#: src/pages/settings.jsx:1064
#: src/pages/settings.jsx:1069
msgid "Failed to update subscription. Please try again."
msgstr "Falhou ao atualizar subscrição. Tente novamente."

#: src/pages/settings.jsx:1075
msgid "Failed to remove subscription. Please try again."
msgstr "Falhou ao remover subscrição. Tente novamente."

#: src/pages/settings.jsx:1082
msgid "Push Notifications (beta)"
msgstr "Notificações de push (beta)"

#: src/pages/settings.jsx:1104
msgid "Push notifications are blocked. Please enable them in your browser settings."
msgstr "As notificações de push estão bloqueadas. Por favor, habilite-as nas definições do seu navegador."

#. placeholder {0}: [ { value: 'all', label: t`anyone`, }, { value: 'followed', label: t`people I follow`, }, { value: 'follower', label: t`followers`, }, ].map((type) => ( <option value={type.value}>{type.label}</option> ))
#: src/pages/settings.jsx:1113
msgid "Allow from <0>{0}</0>"
msgstr "Permitir de <0>{0}</0>"

#: src/pages/settings.jsx:1122
msgid "anyone"
msgstr "qualquer um"

#: src/pages/settings.jsx:1126
msgid "people I follow"
msgstr "pessoas que sigo"

#: src/pages/settings.jsx:1130
msgid "followers"
msgstr "seguidores"

#: src/pages/settings.jsx:1163
msgid "Follows"
msgstr "Segue"

#: src/pages/settings.jsx:1171
msgid "Polls"
msgstr "Votações"

#: src/pages/settings.jsx:1175
msgid "Post edits"
msgstr "Publicar edições"

#: src/pages/settings.jsx:1196
msgid "Push permission was not granted since your last login. You'll need to <0><1>log in</1> again to grant push permission</0>."
msgstr "A permissão de push não foi concedida desde a última sessão. Precisas <0><1>iniciar sessão</1> novamente para conceder a permissão</0>."

#: src/pages/settings.jsx:1212
msgid "NOTE: Push notifications only work for <0>one account</0>."
msgstr "NOTA: Notificações de push só funcionam para <0>uma conta</0>."

#. js-lingui-explicit-id
#: src/pages/status.jsx:599
#: src/pages/status.jsx:1151
msgid "post.title"
msgstr "Publicação"

#: src/pages/status.jsx:842
msgid "You're not logged in. Interactions (reply, boost, etc) are not possible."
msgstr "Não estás conectado. Interações como (respostas, impulsos, etc.) não são possíveis."

#: src/pages/status.jsx:862
msgid "This post is from another instance (<0>{instance}</0>). Interactions (reply, boost, etc) are not possible."
msgstr "Esta publicação é de outra instância (<0>{instance}</0>). Interações como (respostas, impulsos, etc.) não são possíveis."

#: src/pages/status.jsx:890
msgid "Error: {e}"
msgstr "Erro: {e}"

#: src/pages/status.jsx:897
msgid "Switch to my instance to enable interactions"
msgstr "Alterar para a minha instância para ativar interações"

#: src/pages/status.jsx:999
msgid "Unable to load replies."
msgstr "Impossível carregar respostas."

#: src/pages/status.jsx:1111
msgid "Back"
msgstr "Voltar"

#: src/pages/status.jsx:1142
msgid "Go to main post"
msgstr "Ir à publicação principal"

#. placeholder {0}: ancestors.length
#: src/pages/status.jsx:1165
msgid "{0} posts above ‒ Go to top"
msgstr "{0} publicações acima – Voltar ao topo"

#: src/pages/status.jsx:1208
#: src/pages/status.jsx:1271
msgid "Switch to Side Peek view"
msgstr "Alterar para visualização lateral"

#: src/pages/status.jsx:1272
msgid "Switch to Full view"
msgstr "Alterar para visualização completa"

#: src/pages/status.jsx:1290
msgid "Show all sensitive content"
msgstr "Mostrar conteúdo sensível"

#: src/pages/status.jsx:1295
msgid "Experimental"
msgstr "Experimental"

#: src/pages/status.jsx:1304
msgid "Unable to switch"
msgstr "Impossível alterar"

#. placeholder {0}: punycode.toUnicode( postInstance, )
#: src/pages/status.jsx:1311
msgid "Switch to post's instance ({0})"
msgstr "Alterar para instância da publicação ({0})"

#: src/pages/status.jsx:1314
msgid "Switch to post's instance"
msgstr "Alterar para instância da publicação"

#: src/pages/status.jsx:1372
msgid "Unable to load post"
msgstr "Impossível carregar publicação"

#. placeholder {0}: replies.length
#. placeholder {1}: shortenNumber(replies.length)
#: src/pages/status.jsx:1508
msgid "{0, plural, one {# reply} other {<0>{1}</0> replies}}"
msgstr "{0, plural, one {# resposta} other {<0>{1}</0> respostas}}"

#. placeholder {0}: shortenNumber(totalComments)
#: src/pages/status.jsx:1526
msgid "{totalComments, plural, one {# comment} other {<0>{0}</0> comments}}"
msgstr "{totalComments, plural, one {# comentário} other {<0>{0}</0> comentários}}"

#: src/pages/status.jsx:1548
msgid "View post with its replies"
msgstr "Ver publicação com respostas"

#: src/pages/trending.jsx:73
msgid "Trending ({instance})"
msgstr "Tendência ({instance})"

#: src/pages/trending.jsx:230
msgid "Trending News"
msgstr "Notícias em tendência"

#. By [Author]
#. placeholder {0}: author ? ( <NameText account={author} showAvatar /> ) : authorUrl ? ( <a href={authorUrl} target="_blank" rel="noopener" > {authorName} </a> ) : ( authorName )
#: src/pages/trending.jsx:345
msgid "By {0}"
msgstr "Por {0}"

#: src/pages/trending.jsx:406
msgid "Back to showing trending posts"
msgstr "Voltar a mostrar publicações em tendência"

#. placeholder {0}: currentLink .replace(/^https?:\/\/(www\.)?/i, '') .replace(/\/$/, '')
#: src/pages/trending.jsx:411
msgid "Showing posts mentioning <0>{0}</0>"
msgstr "Mostrar publicações mencionando <0>{0}</0>"

#: src/pages/trending.jsx:423
msgid "Trending posts"
msgstr "Publicações em tendência"

#: src/pages/trending.jsx:446
msgid "No trending posts."
msgstr "Nenhuma publicação em tendência."

#: src/pages/welcome.jsx:54
msgid "A minimalistic opinionated Mastodon web client."
msgstr "Um cliente web minimalista e original para Mastodon."

#: src/pages/welcome.jsx:65
msgid "Log in with Mastodon"
msgstr "Iniciar sessão com Mastodon"

#: src/pages/welcome.jsx:71
msgid "Sign up"
msgstr "Iniciar sessão"

#: src/pages/welcome.jsx:78
msgid "Connect your existing Mastodon/Fediverse account.<0/>Your credentials are not stored on this server."
msgstr "Conecte com a sua conta existente do Mastodon/Fediverse.<0/>Os seus credenciais não serão guardados neste servidor."

#: src/pages/welcome.jsx:95
msgid "<0>Built</0> by <1>@cheeaun</1>. <2>Privacy Policy</2>."
msgstr "<0>Feito</0> por <1>@cheeaun</1>. <2>Política de privacidade</2>."

#: src/pages/welcome.jsx:126
msgid "Screenshot of Boosts Carousel"
msgstr "Captura de ecrã do carrossel de impulsos"

#: src/pages/welcome.jsx:130
msgid "Boosts Carousel"
msgstr "Carrossel de impulsos"

#: src/pages/welcome.jsx:133
msgid "Visually separate original posts and re-shared posts (boosted posts)."
msgstr "Separa visualmente as publicações originais das partilhadas (publicações impulsionadas)."

#: src/pages/welcome.jsx:142
msgid "Screenshot of nested comments thread"
msgstr "Captura de ecrã de tópicos de comentários aninhados"

#: src/pages/welcome.jsx:146
msgid "Nested comments thread"
msgstr "Tópico de comentários aninhados"

#: src/pages/welcome.jsx:149
msgid "Effortlessly follow conversations. Semi-collapsible replies."
msgstr "Siga facilmente as conversas. Respostas semi-colapsáveis."

#: src/pages/welcome.jsx:157
msgid "Screenshot of grouped notifications"
msgstr "Captura de ecrã de notificações agrupadas"

#: src/pages/welcome.jsx:161
msgid "Grouped notifications"
msgstr "Notificações agrupadas"

#: src/pages/welcome.jsx:164
msgid "Similar notifications are grouped and collapsed to reduce clutter."
msgstr "Notificações similares são agrupadas e colapsadas para evitar desordem."

#: src/pages/welcome.jsx:173
msgid "Screenshot of multi-column UI"
msgstr "Captura de ecrã do UI multi-coluna"

#: src/pages/welcome.jsx:177
msgid "Single or multi-column"
msgstr "Única ou multi-coluna"

#: src/pages/welcome.jsx:180
msgid "By default, single column for zen-mode seekers. Configurable multi-column for power users."
msgstr "Por padrão, uma coluna única para amantes do modo zen. Multi-coluna configurável para utilizadores avançados."

#: src/pages/welcome.jsx:189
msgid "Screenshot of multi-hashtag timeline with a form to add more hashtags"
msgstr "Captura de ecrã da linha de tempo multi-hashtag com uma forma de adicionar mais hashtags"

#: src/pages/welcome.jsx:193
msgid "Multi-hashtag timeline"
msgstr "Linha de tempo multi-hashtag"

#: src/pages/welcome.jsx:196
msgid "Up to 5 hashtags combined into a single timeline."
msgstr "Até 5 hashtags combinadas em uma única linha do tempo."

#: src/utils/open-compose.js:24
msgid "Looks like your browser is blocking popups."
msgstr "Parece que o seu navegador está a bloquear pop-ups."

#: src/utils/show-compose.js:16
msgid "A draft post is currently minimized. Post or discard it before creating a new one."
msgstr "Uma publicação rascunho está atualmente minimizada. Publique-a ou a descarte antes de criar uma."

#: src/utils/show-compose.js:21
msgid "A post is currently open. Post or discard it before creating a new one."
msgstr "Uma publicação está atualmente aberta. Publique-a ou a descarte antes de criar uma."

